// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Translations for HI
 * @file translations.hi.js
 * @description Main application translations for hi
 * @version v3.1.0
 */

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsHi = {
                'login.title': 'लॉग इन करें',
                'login.slogan': 'सीमाओं के बिना बातचीत!',
                'login.username': 'उपयोगकर्ता नाम',
                'login.password': 'पासवर्ड',
                'login.submit': 'लॉग इन करें',
                'login.loading': 'लोड हो रहा है...',
                'login.autoRegister.title': 'स्वचालित पंजीकरण',
                'login.autoRegister.description': 'यदि आपके पास खाता नहीं है, तो अपना उपयोगकर्ता नाम और पासवर्ड दर्ज करें। यह स्वचालित रूप से बनाया जाएगा।',
                'login.forgotPassword': 'पासवर्ड भूल गए?',
                'login.passwordRecovery.title': 'पासवर्ड पुनर्प्राप्त करें',
                'login.passwordRecovery.description': 'पुनर्प्राप्ति लिंक प्राप्त करने के लिए अपना ईमेल दर्ज करें।',
                'login.passwordRecovery.emailLabel': 'ईमेल',
                'login.passwordRecovery.emailPlaceholder': 'अपना ईमेल दर्ज करें',
                'login.passwordRecovery.emailHelp': 'पुनर्प्राप्ति लिंक आपके ईमेल पर भेजा जाएगा',
                'login.passwordRecovery.send': 'भेजें',
                'login.passwordRecovery.success': 'पुनर्प्राप्ति लिंक आपके ईमेल पर भेजा गया है। अपना इनबॉक्स जांचें।',
                'login.passwordRecovery.successTitle': 'ईमेल भेजा गया',
                'login.passwordRecovery.successMessage': 'हमने आपको पासवर्ड रीसेट करने के निर्देशों के साथ ईमेल भेजा है।\nकृपया अपना इनबॉक्स और स्पैम फ़ोल्डर जांचें। लिंक आने में कुछ मिनट लग सकते हैं।',
                'login.passwordRecovery.devExplanation': 'विकास मोड में ईमेल आपके इनबॉक्स में नहीं भेजा जाता; यह पूर्वावलोकन के लिए सहेजा जाता है। सामग्री और पुनर्प्राप्ति लिंक देखने के लिए «ईमेल देखें» का उपयोग करें।',
                'login.passwordRecovery.devSinkNotice': '⚠️ विकास मोड: यह ईमेल आपके इनबॉक्स में नहीं भेजा गया। जनरेट किए गए संदेश और लिंक खोलने के लिए «ईमेल देखें» का उपयोग करें।',
                'login.passwordRecovery.invalidEmail': 'कृपया एक वैध ईमेल पता दर्ज करें',
                'login.error.invalidPassword': 'अमान्य पासवर्ड',
                'common.language': 'भाषा',
                'common.loading': 'लोड हो रहा है…',
                'common.back': 'वापस',
                'common.backToStart': 'होम पर वापस जाएं',
                'common.changeUser': 'उपयोगकर्ता बदलें',
                'common.request_id_label': 'अनुरोध ID',
                'login.email.invalid': 'कृपया एक वैध ईमेल दर्ज करें',
                'captcha.solve': 'कृपया CAPTCHA सही से हल करें',
                'captcha.generateError': 'CAPTCHA उत्पन्न करने में त्रुटि। पृष्ठ पुनः लोड करें।',
                'auth.require_email': 'पंजीकरण पूरा करने के लिए ईमेल आवश्यक है। कृपया अपना ईमेल दर्ज करें।',
                'auth.invalid_credentials': 'गलत उपयोगकर्ता नाम या पासवर्ड।',
                'auth.account_blocked': 'खाता निष्क्रिय है। पुनः सक्रिय करने के लिए ईमेल दर्ज करें।',
                'auth.device_limit_reached': 'डिवाइस सीमा पूर्ण। किसी अन्य डिवाइस से साइन आउट करें या अपना प्लान अपग्रेड करें।',
                'auth.login.device_limit.title': 'सत्र या डिवाइस सीमा पूर्ण',
                'auth.login.device_limit.body': 'आपकी योजना में एक साथ सक्रिय सत्रों या डिवाइसों की संख्या सीमित है। साइन इन करने के लिए, किसी अन्य डिवाइस से साइन आउट करें या कोई अन्य सक्रिय सत्र बंद करें, फिर पुनः प्रयास करें।',
                'auth.password_incorrect': 'पासवर्ड गलत है।',
                'auth.login.password_error_title': 'गलत पासवर्ड',
                'auth.login.password_attempts_hint': 'अपना पासवर्ड सही ढंग से दर्ज करने के लिए आपके पास 3 अवसर हैं। यदि आप इनसे अधिक प्रयास करते हैं, तो आपको पासवर्ड रीसेट करना होगा।',
                'auth.login.password_attempts_exhausted_title': 'प्रयास सीमा पूर्ण',
                'auth.login.password_attempts_exhausted_body': 'आपने अनुमत 3 प्रयासों को पार कर लिया है। जारी रखने के लिए «पासवर्ड भूल गए?» से पासवर्ड रीसेट करें।',
                'auth.login.go_to_reset_password': 'पासवर्ड रीसेट पर जाएँ',
                'auth.login.password_remaining_two': 'आपके पास 2 प्रयास शेष हैं।',
                'auth.login.password_remaining_one': 'आपके पास 1 प्रयास शेष है।',
                'auth.login.password_attempts_locked_inline': 'अधिकतम प्रयासों की संख्या पूरी हो गई है। आपको पासवर्ड रीसेट करना होगा।',
                'auth.account_inactive_email_mismatch': 'खाता निष्क्रिय है और ईमेल मेल नहीं खाता।',
                'auth.captcha_failed': 'CAPTCHA गलत है। अपना उत्तर जांचें।',
                'auth.captcha_expired': 'आपकी सत्यापन की समय सीमा समाप्त हो गई। एक नया स्वचालित रूप से जनरेट किया गया है।',
                'auth.unauthorized': 'आपके पास पहुंच की अनुमति नहीं है।',
                'auth.generic_error': 'एक त्रुटि हुई। कृपया पुनः प्रयास करें।',
                'auth.method_not_allowed': 'विधि की अनुमति नहीं है।',
                'auth.invalid_data': 'अमान्य डेटा।',
                'auth.credentials_required': 'उपयोगकर्ता नाम और पासवर्ड आवश्यक हैं।',
                'auth.csrf_invalid': 'अमान्य सत्र। पृष्ठ पुनः लोड करें और पुनः प्रयास करें।',
                'auth.username_taken': 'यह उपयोगकर्ता नाम पहले से पंजीकृत है। लॉगिन करें या दूसरा चुनें।',
                'auth.username_unavailable': 'यह उपयोगकर्ता नाम उपलब्ध नहीं है।',
                'auth.nick_no_spaces': 'Nicknames cannot contain spaces.',
                'auth.password_too_short': 'पासवर्ड कम से कम 6 अक्षर का होना चाहिए।',
                'auth.rate_limit': 'बहुत अधिक प्रयास। थोड़ी प्रतीक्षा करें और पुनः प्रयास करें।',
                'auth.confirm_success': 'खाता सफलतापूर्वक पुष्टि हुआ। लॉगिन पर रीडायरेक्ट हो रहा है...',
                'auth.confirm_already_active': 'आपका खाता पहले से सक्रिय है। आप लॉगिन कर सकते हैं।',
                'auth.reset_sent': 'यदि ईमेल पंजीकृत है, तो आपको पासवर्ड रीसेट निर्देश प्राप्त होंगे।',
                'auth.reset_token_invalid': 'लिंक अमान्य या गायब है।',
                'auth.reset_token_expired': 'इस लिंक की समय सीमा समाप्त हो गई। "पासवर्ड भूल गए?" से नया अनुरोध करें।',
                'auth.reset_done': 'पासवर्ड अपडेट हो गया। अब आप लॉग इन कर सकते हैं।',
                'auth.reset_fatal': 'सहेजने में त्रुटि। कृपया बाद में पुनः प्रयास करें।',
                'auth.password_mismatch': 'पासवर्ड मेल नहीं खाते।',
                'resetPassword.page.title': 'नया पासवर्ड',
                'resetPassword.page.description': 'अपना नया पासवर्ड दर्ज करें (कम से कम 6 अक्षर)।',
                'resetPassword.newPassword': 'नया पासवर्ड',
                'resetPassword.newPasswordPlaceholder': 'कम से कम 6 अक्षर',
                'resetPassword.submit': 'पासवर्ड रीसेट करें',
                'resetPassword.success': 'पासवर्ड अपडेट हो गया। लॉगिन पर रीडायरेक्ट हो रहा है...',
                'resetPassword.backToLogin': 'लॉगिन पर वापस जाएं',

                'account.delete.section_title': 'खाता हटाएं',
                'account.delete.description': 'अपना खाता हटाने पर आपका सारा डेटा, संदेश, संपर्क और सेटिंग स्थायी रूप से हट जाएगी। इसे पूर्ववत नहीं किया जा सकता।',
                'account.delete.button': 'मेरा खाता हटाएं',
                'accountDeletion.title': 'खाता और डेटा हटाना',
                'accountDeletion.description': 'अपने ArChat खाते और संबंधित डेटा को हटाने का अनुरोध करें।',
                'accountDeletion.openRequest': 'खाता और डेटा हटाने का अनुरोध करें',
                'account.delete.confirm_title': 'खाता हटाएं',
                'account.delete.confirm_message': 'क्या आप वाकई अपना खाता हटाना चाहते हैं? आपके इनबॉक्स में एक पुष्टिकरण ईमेल भेजा जाएगा। हटाना स्थायी और अपरिवर्तनीय है।',
                'account.delete.email_sent_title': 'ईमेल भेजा गया',
                'account.delete.email_sent': 'हमने आपको पुष्टिकरण ईमेल भेजा है। इनबॉक्स जांचें और हटाने की पुष्टि के लिए लिंक पर क्लिक करें।',
                'account.delete.error': 'अनुरोध संसाधित नहीं हो सका। पुनः प्रयास करें।',
                'account.delete.confirm_page_title': 'खाता हटाने की पुष्टि करें',
                'account.delete.confirm_page_desc': 'आप अपना ArChat खाता स्थायी रूप से हटाने वाले हैं। सारा डेटा, संदेश, संपर्क और सेटिंग हटा दी जाएगी। इसे पूर्ववत नहीं किया जा सकता।',
                'account.delete.confirm_final_button': 'हाँ, मेरा खाता स्थायी रूप से हटाएं',
                'account.delete.cancel_go_back': 'रद्द करें और वापस जाएं',
                'account.delete.done_title': 'खाता हटा दिया गया',
                'account.delete.done_message': 'आपका खाता सफलतापूर्वक हटा दिया गया। सारा डेटा हटा दिया गया।',
                'account.delete_token_expired': 'हटाने का लिंक समाप्त हो गया या अब मान्य नहीं है। प्रोफ़ाइल से नया अनुरोध करें।',
                'account.delete_token_invalid': 'अमान्य या गुम हटाने का लिंक।',
                'account.delete_email_failed': 'पुष्टिकरण ईमेल नहीं भेजा जा सका। बाद में प्रयास करें।',
                'account.delete_error': 'हटाते समय त्रुटि। बाद में प्रयास करें।',

                'auth.register_success_email_sent': 'खाता सफलतापूर्वक बनाया गया। पुष्टिकरण ईमेल भेजा गया। इनबॉक्स (और स्पैम फ़ोल्डर) जांचें और खाता सक्रिय करने के लिए लिंक पर क्लिक करें।',
                'auth.register_success_email_pending': 'खाता बना लेकिन पुष्टिकरण ईमेल भेजने में समस्या हुई। सक्रियण टोकन अभी भी वैध है। व्यवस्थापक से संपर्क करें या नया पुष्टिकरण ईमेल अनुरोध करें।',
                'auth.email_not_verified': 'खाता सक्रिय करने के लिए ईमेल की पुष्टि करें।',
                'auth.email_not_verified_title': 'खाता पुष्टि लंबित',
                'auth.email_send_failed': 'ईमेल भेजने में असमर्थ। पुनः प्रयास करें या ईमेल बदलें।',
                'auth.email_send_failed_title': 'ईमेल भेजने में असमर्थ',
                'auth.register.email_failed.title': 'खाता बनाया गया',
                'auth.register.email_failed.message': 'आपका खाता सफलतापूर्वक बनाया गया, लेकिन पुष्टिकरण ईमेल भेजने में समस्या हुई। स्पैम जाँचें या नया ईमेल अनुरोध करें।',
                'auth.register.success.title': 'खाता बनाया गया',
                'auth.register.success.message': 'खाता सफलतापूर्वक बनाया गया। पुष्टिकरण ईमेल भेजा गया। इनबॉक्स (और स्पैम फ़ोल्डर) जांचें और खाता सक्रिय करने के लिए लिंक पर क्लिक करें।',
                'auth.resend_sent': 'पुष्टिकरण ईमेल पुनः भेजा गया।',
                'auth.resend_email': 'ईमेल पुनः भेजें',
                'auth.retry_resend': 'पुनः प्रयास करें',
                'auth.change_email': 'ईमेल बदलें',
                'auth.ver_email': 'ईमेल देखें',
                'auth.already_verified': 'खाता पहले से सत्यापित है।',
                'auth.confirm_email_title': 'ईमेल की पुष्टि करें',
                'auth.confirm_email_text': 'सक्रियण लिंक भेजा जाएगा:',
                'auth.confirm_email_edit': 'संपादित करें',
                'auth.confirm_email_confirm': 'पुष्टि करें',
                'auth.confirm_email_typo_hint': 'क्या आपका मतलब ***@{suggestion} था?',
                'brand.slogan': 'भाषा की परवाह किए बिना समझे जाने की शक्ति',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': 'भाषा की परवाह किए बिना समझे जाने की शक्ति',
                'home.tagline': 'स्वचालित अनुवाद के साथ मैसेजिंग',
                'home.login': 'लॉग इन करें',
                'home.register': 'खाता बनाएं',
                'home.language': 'भाषा',
                'terms.title': 'नियम और शर्तें',
                'terms.accept': 'स्वीकार करें और जारी रखें',
                'terms.reject': 'अस्वीकार करें',
                'terms.rejectShort': 'स्वीकार नहीं',
                'terms.readAndAccept': 'मैंने नियम और शर्तें पढ़ी हैं और स्वीकार करता हूं',
                'terms.cancel': 'रद्द करें',
                'register.pageTitle': 'खाता बनाएं',
                'register.pageSubtitle': 'अपना खाता बनाने के लिए जानकारी दर्ज करें।',
                'register.submitLabel': 'खाता बनाएं',
                'register.confirm_title': 'खाता पुष्टि करें',
                'register.confirm_message': 'आप खाता बनाने जा रहे हैं:',
                'register.confirm': 'पुष्टि करें',
                'register.login_link': 'पहले से खाता है?',
                'register.password_hint': 'कम से कम 6 अक्षर',
                'register.checking': 'जाँच हो रही है…',
                'register.username_taken': 'यह उपयोगकर्ता नाम पहले से उपयोग में है।',
                'register.available': 'उपलब्ध',
                'register.emailAlreadyExists': 'यह ईमेल पहले से पंजीकृत है.',
                'register.continue': 'जारी रखें',
                'login.demo.title': 'डेमो पहुंच',
                'login.demo.credentials': 'उपयोगकर्ता: demo / पासवर्ड: demo',
                'captcha.label': 'सुरक्षा सत्यापन',
                'security.verification_title': 'सुरक्षा सत्यापन',
                'security.captcha_question': 'सत्यापन प्रश्न',
                'security.enter_answer': 'उत्तर दर्ज करें',
                'captcha.description': 'यह सत्यापित करने के लिए गणितीय ऑपरेशन हल करें कि आप मानव हैं',
                'captcha.required': 'जारी रखने के लिए कृपया CAPTCHA उत्तर दर्ज करें।',
                'menu.conversations': 'बातचीत',
                'menu.contacts': 'संपर्क',
                'menu.dashboard': 'डैशबोर्ड',
                'menu.profile': 'मेरी प्रोफ़ाइल',
                'menu.settings': 'सेटिंग्स',
                'menu.help': 'मदद',
                'menu.logout': 'लॉग आउट',
                'menu.files': 'मेरी फ़ाइलें',
                'reviews.menu_title': 'समीक्षाएँ',
                'reviews.rate_archat': 'ArChat को रेट करें',
                'reviews.my_review': 'मेरी समीक्षा',
                'navbar.contacts': 'संपर्क',
                'navbar.profile': 'मेरी प्रोफ़ाइल',
                'navbar.settings': 'सेटिंग्स',
                'navbar.logout': 'लॉग आउट',
                'onboarding.welcome_title': 'ArChat® में आपका स्वागत है',
                'onboarding.welcome_subtitle': 'किसी भी व्यक्ति से किसी भी भाषा में संवाद करें।',
                'onboarding.step1': 'चरण 1',
                'onboarding.step1_title': 'चरण 1',
                'onboarding.step1_description': 'अपने पहले संपर्क को आमंत्रित करें',
                'onboarding.step2': 'चरण 2',
                'onboarding.step2_title': 'चरण 2',
                'onboarding.step2_description': 'अपना पहला संदेश भेजें',
                'onboarding.invite_contact': 'संपर्क आमंत्रित करें',
                'onboarding.explore_archat': 'ArChat® एक्सप्लोर करें',
                'contacts.invite_contact': 'संपर्क आमंत्रित करें',
                'contacts.no_contacts': 'कोई संपर्क नहीं',
                'help.view_initial_guide': 'प्रारंभिक गाइड देखें',
                'suggestions.title': 'सुझाव',
                'suggestions.form.title': 'सुझाव का शीर्षक',
                'suggestions.form.message': 'अपने विचार का वर्णन करें',
                'suggestions.form.submit': 'सुझाव भेजें',
                'suggestions.send': 'सुझाव भेजें',
                'suggestions.captcha_placeholder': 'परिणाम',
                'suggestions.cooldown': 'दूसरा सुझाव भेजने से पहले आपको {minutes} मिनट प्रतीक्षा करनी होगी।',
                'suggestions.success_title': 'सुझाव भेजा गया',
                'suggestions.success_message': 'आपका सुझाव सफलतापूर्वक भेजा गया। ट्रैकिंग नंबर: {id}',
                'suggestions.success': 'आपके सुझाव के लिए धन्यवाद। हमारी टीम इसकी समीक्षा करेगी।',
                'suggestions.success.title': 'आपके सुझाव के लिए धन्यवाद!',
                'suggestions.success.reference': 'संदर्भ',
                'suggestions.success.review': 'हमारी टीम आपके विचार की समीक्षा करेगी।',
                'suggestions.success.email': 'हमने आपको एक पुष्टिकरण ईमेल भी भेजा है।',
                'suggestions.success.copy': 'कॉपी करें',
                'suggestions.success.copied': 'संदर्भ कॉपी हो गया',
                'suggestions.form.required': 'शीर्षक और संदेश आवश्यक हैं।',
                'suggestions.error': 'भेजने में असमर्थ। कृपया पुनः प्रयास करें।',
                'profile.title': 'मेरी प्रोफ़ाइल',
                'profile.founderBadge': 'संस्थापक #{position}/{limit}',
                'profile.founderTooltip': 'संस्थापक सदस्य – जब तक सदस्यता सक्रिय है तब तक आजीवन स्थिर मूल्य',
                'profile.founderMember': 'संस्थापक सदस्य',
                'profile.founderHeaderBadge': '★ संस्थापक #{position}/150',
                'profile.camera.access_denied': 'कैमरा एक्सेस नहीं हो सका। अनुमतियाँ जाँचें।',
                'profile.edit': 'संपादित करें',
                'profile.save': 'परिवर्तन सहेजें',
                'profile.save.success': 'आपकी प्रोफ़ाइल सफलतापूर्वक अपडेट हो गई है।',
                'profile.save.success.title': 'प्रोफ़ाइल अपडेट',
                'profile.update.success.title': 'प्रोफ़ाइल अपडेट',
                'profile.update.success.message': 'आपके परिवर्तन सहेजे गए।',
                'profile.save.error': 'प्रोफ़ाइल अपडेट नहीं की जा सकी। कृपया पुनः प्रयास करें।',
                'profile.save.error.title': 'सहेजने में त्रुटि',
                'profile.cancel': 'रद्द करें',
                'profile.nick': 'उपयोगकर्ता नाम',
                'profile.nick.help': 'सिस्टम में आपका अद्वितीय पहचानकर्ता',
                'profile.name': 'वास्तविक नाम',
                'profile.lastname': 'उपनाम',
                'profile.alias': 'उपनाम',
                'profile.email': 'ईमेल',
                'profile.phone': 'फोन',
                'profile.language': 'भाषा',
                'profile.country': 'देश',
                "profile.country.select": "देश चुनें",
                'profile.biography': 'जीवनी',
                'bio.modal.original': 'मूल',
                'bio.modal.translation': 'अनुवाद',
                'bio.modal.empty': 'इस संपर्क की कोई जीवनी नहीं है।',
                'bio.modal.translating': 'अनुवाद हो रहा है...',
                'bio.modal.translation_error': 'जीवनी का अनुवाद नहीं हो सका।',
                'attachment.unnamed_file': 'फ़ाइल',
                'auth.login_error.default_title': 'पहुंच त्रुटि',
                'auth.login_error.default_message': 'साइन इन नहीं हो सका।',
                'profile.photo': 'प्रोफ़ाइल फोटो',
                'notifications.bell.aria': 'सूचनाएँ',
                'notifications.panel.title': 'सूचनाएँ',
                'notifications.empty': 'कोई सूचना नहीं',
                'notifications.mark_read': 'खोलने पर पढ़ा चिह्नित करें',
                'billing.change_plan': 'प्लान बदलें',
                'billing.usage.title': 'योजना का उपयोग',
                'billing.usage.users': 'उपयोगकर्ता',
                'billing.usage.messages': 'संदेश (आज)',
                'billing.usage.invitations': 'निमंत्रण (आज)',
                'billing.usage.messages_month': 'इस महीने संदेश',
                'billing.usage.chats': 'बातचीत',
                'billing.usage.warning': 'आप अपनी योजना की सीमा के करीब हैं। अधिक क्षमता के लिए PRO में अपग्रेड करें।',
                'plans.limit.reached': 'सीमा पूर्ण — योजना अपग्रेड करें',
                'profile.theme.dark': 'डार्क मोड',
                'profile.theme.light': 'लाइट मोड',
                'profile.theme.argentina': 'अर्जेंटीना थीम',
                'modal.title': 'शीर्षक',
                'modal.success.title': 'सफलता',
                'modal.error.title': 'त्रुटि',
                'modal.warning.title': 'चेतावनी',
                'info.title': 'जानकारी',
                'appearance.title': 'दिखावट',
                'appearance.theme.light': 'हल्का',
                'appearance.theme.dark': 'गहरा',
                'theme.title': 'थीम',
                'theme.light': 'हल्का',
                'theme.dark': 'गहरा',
                'profile.photo.section': 'प्रोफ़ाइल फोटो',
                'profile.personalInfo': 'व्यक्तिगत जानकारी',
                'profile.preferences': 'प्राथमिकताएं',
                'profile.country.help': 'चयनित देश के अनुसार समय क्षेत्र स्वचालित रूप से निर्दिष्ट किया जाएगा',
                'profile.lastname.placeholder': 'आपका उपनाम (वैकल्पिक)',
                'profile.name.placeholder': 'आपका वास्तविक नाम (वैकल्पिक)',
                'profile.biography.placeholder': 'हमें अपने बारे में बताएं...',
                'profile.notifications.sound': 'अधिसूचना ध्वनि',
                'profile.notifications.sound_desc': 'संदेश या महत्वपूर्ण अलर्ट आने पर ध्वनि बजाएं',
                'profile.plan.title': 'सदस्यता योजना',
                'profile.plan.current': 'आपकी वर्तमान योजना',
                'profile.plan.expires': 'समाप्ति तिथि',
                'profile.plan.free.description': 'सीमित सुविधाओं के साथ मुफ्त योजना। सभी सुविधाओं का बिना किसी प्रतिबंध के आनंद लेने के लिए PRO में अपग्रेड करें।',
                'profile.plan.pro.description': 'बहुत बढ़िया! आपके पास ArChat® की सभी प्रीमियम सुविधाओं तक पूर्ण पहुंच है।',
                "profile.plan.upgrade.button": "प्रो में अपग्रेड",
                'profile.plan.upgrade.hint': 'Access all features without limits',
                'profile.photo.change': 'प्रोफ़ाइल फोटो बदलें',
                'message.placeholder': 'संदेश लिखें...',
                'message.placeholderWithFile': 'फ़ाइल भेजें',
                "message.sent_from_country": "प्रेषक",
                "message.sent_at_local_time": "जारीकर्ता का स्थानीय समय",
                "message.timezone_label": "समय क्षेत्र",
                "message.context_info": "यह संदेश जिस समय भेजा गया था उस समय के संदर्भ को सुरक्षित रखता है।",
                "message.context_pro_hint": "इस संदेश में प्रो योजनाओं में समय और भौगोलिक संदर्भ उपलब्ध है।",
                "message.context_pro_badge": "प्रसंग प्रो",
                'message.audio.transcribe': 'ऑडियो ट्रांसक्राइब करें',
                'message.audio.transcribing': 'ट्रांसक्राइब हो रहा है...',
                'message.audio.transcription': 'ट्रांसक्रिप्शन',
                'message.audio.error': 'ऑडियो ट्रांसक्राइब नहीं किया जा सका',
                'attachment.title': 'फ़ाइल संलग्न करें',
                'attachment.close': 'बंद करें',
                'attachment.gallery': 'फोटो/वीडियो गैलरी',
                'attachment.cameraFront': 'फ्रंट कैमरा',
                'attachment.cameraBack': 'बैक कैमरा',
                'attachment.cameraWeb': 'वेब कैमरा',
                'attachment.recordAudio': 'माइक्रोफ़ोन के साथ ऑडियो रिकॉर्ड करें',
                'attachment.selectFile': 'फ़ाइल चुनें (ऑडियो, वीडियो, टेक्स्ट, PDF)',
                'attachment.remove': 'हटाएं',
                'attachments.recipientFreeBlocked.title': 'योजना सीमा',
                'attachments.recipientFreeBlocked.sender': 'इस उपयोगकर्ता की Free योजना है; वे अटैचमेंट नहीं ले सकते।',
                'attachments.recipientFreeBlocked.receiver': '{senderName} ने आपको अटैचमेंट भेजने की कोशिश की, लेकिन आपकी {planName} योजना अटैचमेंट नहीं ले सकती। फ़ाइलें पाने के लिए उच्च प्लान अपनाने की सिफारिश है।',
                'attachments.recipientFreeBlocked.upgradeCta': 'प्लान अपग्रेड करें',
                'audio.title': 'ऑडियो रिकॉर्ड करें',
                'audio.close': 'बंद करें',
                'audio.ready': 'रिकॉर्ड करने के लिए तैयार',
                'audio.recording': 'रिकॉर्डिंग...',
                'audio.finished': 'रिकॉर्डिंग समाप्त',
                'audio.start': 'रिकॉर्डिंग शुरू करें',
                'audio.stop': 'रिकॉर्डिंग रोकें',
                'audio.confirm': 'पुष्टि करें और भेजें',
                'audio.rerecord': 'पुन: रिकॉर्ड करें',
                'audio.error.microphone': 'माइक्रोफ़ोन तक पहुंच नहीं सकी। अनुमतियां जांचें।',
                'camera.title': 'कैमरा',
                'camera.close': 'बंद करें',
                'camera.switch': 'कैमरा बदलें',
                'camera.capture': 'फोटो लें',
                'camera.loading': 'कैमरा शुरू हो रहा है...',
                'camera.retry': 'पुनः प्रयास करें',
                'camera.error.access': 'कैमरा तक पहुंच नहीं सकी। अनुमतियां जांचें।',
                'camera.error.permission': 'कैमरा अनुमति अस्वीकृत। कृपया ब्राउज़र सेटिंग्स में कैमरा पहुंच की अनुमति दें।',
                'camera.error.notFound': 'कोई कैमरा नहीं मिला।',
                'camera.error.busy': 'कैमरा दूसरे एप्लिकेशन द्वारा उपयोग किया जा रहा है।',
                'camera.error.constraint': 'कैमरा बाधाओं को पूरा नहीं किया जा सकता।',
                'profile.photo.take': 'फोटो लें',
                'profile.photo.gallery': 'गैलरी से चुनें',
                'profile.photo.uploading': 'छवि अपलोड हो रही है...',
                'profile.photo.upload.success': 'प्रोफ़ाइल फोटो सफलतापूर्वक अपडेट किया गया',
                'profile.photo.upload.success.title': 'फोटो अपडेट किया गया',
                'profile.photo.upload.error': 'प्रोफ़ाइल फोटो अपलोड करने में त्रुटि। कृपया पुनः प्रयास करें।',
                'profile.photo.upload.error.title': 'अपलोड त्रुटि',
                'user.default': 'उपयोगकर्ता',
                'logout.title': 'पुष्टि करें',
                'logout.confirm': 'क्या आप वाकई लॉग आउट करना चाहते हैं?',
                'contacts.title': 'संपर्क',
                'contacts.search': 'संपर्क खोजें',
                'contacts.search.placeholder': 'Nick, नाम, उपनाम, देश या भाषा से खोजें...',
                'contacts.sort': 'क्रमबद्ध करें',
                'contacts.sortByName': 'नाम से',
                'contacts.sortByStatus': 'स्थिति से',
                'contacts.sortByRecent': 'हाल के',
                'contacts.filter': 'फ़िल्टर',
                'contacts.filterAll': 'सभी',
                'contacts.filterAvailable': 'उपलब्ध',
                'contacts.filterInvited': 'आमंत्रित',
                'contacts.filterBlocked': 'अवरुद्ध',
                'contacts.pending_invitations': 'लंबित निमंत्रण',
                'contacts.status.invitation_sent': 'निमंत्रण भेजा गया',
                'contacts.empty': 'कोई संपर्क नहीं',
                'contacts.empty.title': 'आपके पास अभी तक कोई संपर्क नहीं है',
                'contacts.empty.message': 'चैट शुरू करने के लिए किसी को आमंत्रित करें या जोड़ें।',
                'contacts.empty.invite_button': 'संपर्क आमंत्रित करें',
                'contacts.empty.private.message': 'आपकी प्रोफ़ाइल निजी है। चैट शुरू करने के लिए संपर्कों को आमंत्रित करें।',
                'contacts.empty.private.invite_button': 'संपर्क आमंत्रित करें',
                'contacts.search.no_results': 'कोई संपर्क नहीं मिला',
                'contacts.search.clear': 'सभी दिखाएं',
                'contacts.controls.search_placeholder': 'संपर्क खोजें...',
                'contacts.controls.search_label': 'संपर्क खोजें',
                'contacts.controls.sort_label': 'क्रमबद्ध करें',
                'contacts.controls.sort.name': 'नाम',
                'contacts.controls.sort.status': 'स्थिति',
                'contacts.controls.sort.recent': 'हाल के',
                'contacts.controls.sort.manual': 'मैन्युअल',
                'contacts.controls.sort.manual_drag_hint': 'क्रम बदलने के लिए खींचें',
                'contacts.controls.filter_label': 'स्थिति',
                'contacts.controls.filter.all': 'सभी',
                'contacts.controls.filter.available': 'उपलब्ध',
                'contacts.controls.filter.invited': 'आमंत्रित',
                'contacts.controls.filter.blocked': 'अवरुद्ध',
                'contacts.controls.filter.favorites': 'पसंदीदा',
                'contacts.nick': 'उपयोगकर्ता नाम',
                'contacts.name': 'नाम',
                'contacts.lastname': 'उपनाम',
                'contacts.country': 'देश',
                'contacts.language': 'भाषा',
                'contacts.status': 'स्थिति',
                'status.available': 'उपलब्ध',
                'status.busy': 'व्यस्त',
                'status.in_call': 'कॉल पर',
                'status.away': 'दूर',
                'status.offline': 'ऑफलाइन',
                'status.custom': 'कस्टम संदेश',
                'status.set_title': 'उपलब्धता स्थिति',
                'status.set_button': 'स्थिति बदलें',
                'status.placeholder': 'वैकल्पिक संदेश (जैसे: मीटिंग में)',
                'contacts.status.pending_registration': 'पंजीकरण लंबित',
                'contacts.status.registered': 'आमंत्रित - पंजीकृत',
                'contacts.status.ready_to_chat': 'चैट के लिए तैयार',
                'contacts.status.active_conversation': 'सक्रिय बातचीत',
                'contacts.invitation.pending.title': 'लंबित निमंत्रण',
                'contacts.invitation.pending.message': 'यह निमंत्रण पंजीकरण के लिए लंबित है। संपर्क को पंजीकरण पूरा करने के लिए एक ईमेल प्राप्त होगा। एक बार पंजीकृत होने के बाद, आप उनके साथ चैट कर सकते हैं।',
                'contacts.error.no_registered': 'संपर्क अभी तक पंजीकृत नहीं है। उनके पंजीकरण पूरा होने की प्रतीक्षा करें।',
                'contact.edit.title': 'संपर्क संपादित करें',
                'contact.edit.alias.label': 'कस्टम उपनाम',
                'contact.edit.alias.placeholder': 'उदाहरण: काम से जॉन',
                'contact.edit.alias.help': 'यह नाम वास्तविक नाम के स्थान पर दिखाई देगा',
                'contact.edit.nota.label': 'व्यक्तिगत नोट',
                'contact.edit.nota.placeholder': 'इस संपर्क के बारे में एक नोट जोड़ें...',
                'contact.edit.nota.help': 'निजी नोट केवल आपको दिखाई देते हैं',
                'contact.edit.error.noUser': 'त्रुटि: उपयोगकर्ता की पहचान नहीं की गई',
                'contact.edit.error.noContactId': 'त्रुटि: संपर्क की पहचान नहीं की जा सकी',
                'contact.edit.error.save': 'सहेजने में त्रुटि',
                'contact.limit.title': 'संपर्क सीमा पूरी हो गई',
                'contact.limit.message': 'FREE प्लान में प्रति उपयोगकर्ता अधिकतम 2 संपर्क। बिलिंग सक्षम होने पर FOUNDATION या PRO में अपग्रेड कर अधिक क्षमता पाएँ।',
                'contact.edit.info.personalized': 'ये परिवर्तन केवल आपके लिए व्यक्तिगत हैं और अन्य उपयोगकर्ताओं को प्रभावित नहीं करते हैं।',
                'contact.edit.profileInfo': 'प्रोफ़ाइल जानकारी',
                'export.title': 'बातचीत निर्यात करें',
                'export.description': 'वह प्रारूप चुनें जिसमें आप इस बातचीत को निर्यात करना चाहते हैं:',
                'export.progress': 'निर्यात हो रहा है...',
                "export.format.pdf": "पीडीएफ",
                'export.format.pdf.description': 'सभी छवियों और फ़ाइलों के साथ PDF दस्तावेज़',
                "export.format.html": "एचटीएमएल",
                'export.format.html.description': 'HTML फ़ाइल जिसे आप किसी भी ब्राउज़र में खोल सकते हैं',
                'export.info': 'निर्यात में इस बातचीत के सभी संदेश, छवियाँ और फ़ाइलें शामिल होंगी।',
                'export.pro_required.title': 'बातचीत निर्यात करें',
                'export.pro_required.message': 'यह सुविधा PRO प्लान पर उपलब्ध है।',
                'invitation.title': 'ईमेल द्वारा संपर्क आमंत्रित करें',
                'invitation.modal.title': 'आमंत्रण भेजें',
                'invitation.modal.description': 'किसी को ArChat® पर आपसे चैट करने के लिए आमंत्रित करें। उन्हें आमंत्रण स्वीकार करने के लिए एक लिंक के साथ एक ईमेल प्राप्त होगा।',
                'invitation.email.label': 'आमंत्रित व्यक्ति का ईमेल',
                "invitation.email.placeholder": "ejemplo@email.com",
                'invitation.email.required': 'ईमेल आवश्यक है',
                'invitation.email.invalid': 'कृपया एक वैध ईमेल दर्ज करें',
                'invitation.language.label': 'आमंत्रित व्यक्ति की पसंदीदा भाषा',
                'invitation.language.help': 'ईमेल इस भाषा में भेजा जाएगा',
                'invitation.mode.label': 'बातचीत मोड',
                'invitation.mode.profesional': 'पेशेवर',
                'invitation.mode.profesional.description': 'औपचारिक और पेशेवर बातचीत',
                'invitation.mode.tecnico': 'तकनीकी',
                'invitation.mode.tecnico.description': 'तकनीकी और विशेषज्ञ बातचीत',
                'invitation.mode.casual': 'आकस्मिक',
                'invitation.mode.casual.description': 'अनौपचारिक और मैत्रीपूर्ण बातचीत',
                'invitation.message.label': 'व्यक्तिगत संदेश (वैकल्पिक)',
                'invitation.message.placeholder': 'आमंत्रित व्यक्ति के लिए एक व्यक्तिगत संदेश लिखें...',
                'invitation.send': 'आमंत्रण भेजें',
                'invitation.sending': 'भेज रहा है...',
                'invitation.success': 'आमंत्रण सफलतापूर्वक भेजा गया',
                'invitation.error': 'आमंत्रण भेजने में त्रुटि',
                'invitation.error.self': 'आप खुद को आमंत्रित नहीं कर सकते',
                'invitation.error.duplicate': 'इस ईमेल के लिए पहले से ही एक लंबित आमंत्रण मौजूद है',
                'invitation.list.title': 'भेजे गए आमंत्रण',
                'invitation.list.empty': 'आपने कोई आमंत्रण नहीं भेजा है',
                'invitation.list.email': 'ईमेल',
                'invitation.list.language': 'भाषा',
                'invitation.list.mode': 'मोड',
                'invitation.list.status': 'स्थिति',
                'invitation.list.created': 'भेजा गया',
                'invitation.list.expires': 'समाप्त होता है',
                'invitation.list.actions': 'कार्रवाई',
                'invitation.status.pending': 'लंबित',
                'invitation.status.accepted': 'स्वीकृत',
                'invitation.status.expired': 'समाप्त',
                'invitation.status.cancelled': 'रद्द',
                'invitation.copy.link': 'लिंक कॉपी करें',
                'invitation.copy.success': 'लिंक क्लिपबोर्ड पर कॉपी किया गया',
                'invitation.cancel': 'रद्द करें',
                'invitation.cancel.confirm': 'क्या आप वाकई इस आमंत्रण को रद्द करना चाहते हैं?',
                'invitation.cancel.success': 'आमंत्रण सफलतापूर्वक रद्द किया गया',
                'invitation.cancel.title': 'रद्दीकरण की पुष्टि करें',
                'invitation.resend': 'ईमेल पुनः भेजें',
                'invitation.resend.title': 'आमंत्रण पुनः भेजें',
                'invitation.resend.success': 'आमंत्रण ईमेल सफलतापूर्वक पुनः भेजा गया',
                'invitation.resend.error': 'आमंत्रण ईमेल पुनः भेजने में त्रुटि',
                'invitation.accept.title': 'आमंत्रण स्वीकार करें',
                'invitation.accept.description': 'आपको ArChat® पर चैट करने के लिए आमंत्रित किया गया है',
                'invitation.accept.inviter': 'द्वारा आमंत्रित',
                'invitation.accept.message': 'व्यक्तिगत संदेश',
                'invitation.accept.login': 'लॉग इन करें',
                'invitation.accept.register': 'पंजीकरण करें',
                'invitation.accept.error.invalid': 'अमान्य आमंत्रण टोकन',
                'invitation.accept.error.expired': 'यह आमंत्रण समाप्त हो गया है',
                'invitation.accept.error.accepted': 'यह आमंत्रण पहले से ही स्वीकार किया गया है',
                'invitation.accept.error.cancelled': 'यह आमंत्रण रद्द कर दिया गया था',
                'invitation.accept.error.email_mismatch': 'आपके खाते का ईमेल आमंत्रण ईमेल से मेल नहीं खाता',
                'invitation.accept.success': 'आमंत्रण स्वीकार किया गया। चैट पर पुनर्निर्देशित कर रहे हैं...',
                'invitations.sent.title': 'भेजे गए आमंत्रण',
                'invitations.sent.empty': 'कोई लंबित आमंत्रण नहीं',
                'invitations.pending.title': 'लंबित आमंत्रण',
                'invitations.columns.email': 'ईमेल',
                'invitations.columns.language': 'भाषा',
                'invitations.columns.mode': 'मोड',
                'invitations.columns.status': 'स्थिति',
                'invitations.columns.sentAt': 'भेजा गया',
                'invitations.columns.actions': 'कार्रवाई',
                'invitations.status.pending': 'लंबित',
                'invitations.status.accepted': 'स्वीकृत',
                'invitations.status.cancelled': 'रद्द',
                'invitations.status.expired': 'समाप्त',
                'invitations.actions.cancel': 'रद्द करें',
                'invitations.actions.copy': 'लिंक कॉपी करें',
                'invitations.actions.resend': 'ईमेल पुनः भेजें',
                'profile.privacy.title': 'गोपनीयता',
                'profile.privacy.public_visibility': 'मेरी प्रोफ़ाइल को सार्वजनिक रूप से दृश्यमान बनाएं',
                'profile.privacy.public_warning': 'यह किसी भी ArChat® उपयोगकर्ता को आपको खोजने और बातचीत शुरू करने की अनुमति देता है।',
                'profile.privacy.private_info': 'आपकी प्रोफ़ाइल निजी है। केवल उपयोगकर्ता जिन्हें आप आमंत्रित करते हैं या जो आपको आमंत्रित करते हैं, आपसे चैट कर सकते हैं।',
                'profile.privacy.private_default': 'डिफ़ॉल्ट रूप से, अधिक सुरक्षा के लिए आपकी प्रोफ़ाइल निजी है।',
                'common.close': 'बंद करें',
                'common.cancel': 'रद्द करें',
                'common.confirm': 'पुष्टि करें',
                'common.sending': 'भेजा जा रहा है',
                'common.save': 'सहेजें',
                'common.saving': 'सहेजा जा रहा है...',
                'buttons.accept': 'स्वीकार करें',
                'buttons.cancel': 'रद्द करें',
                'buttons.save': 'सहेजें',
                'buttons.edit': 'संपादित करें',
                'buttons.retry': 'पुनः प्रयास करें',
                'buttons.confirm': 'पुष्टि करें',
                'buttons.yes': 'हाँ',
                'buttons.no': 'नहीं',
                'buttons.send': 'भेजें',
                'buttons.close': 'बंद करें',
                'buttons.continue': 'जारी रखें',
                'buttons.delete': 'हटाएं',
                'buttons.logout': 'लॉग आउट',
                'buttons.back': 'वापस',
                'buttons.update': 'अपडेट करें',
                'buttons.upload': 'अपलोड करें',
                'buttons.select': 'चुनें',
                'conversation.backToContacts': 'संपर्कों पर वापस जाएं',
                'help.title': 'ArChat® मदद',
                'help.what.title': 'ArChat® क्या है?',
                'help.what.description': 'ArChat® एक स्वचालित अनुवाद के साथ तत्काल मैसेजिंग सिस्टम है जो आपको अपनी पसंदीदा भाषा में दुनिया भर के उपयोगकर्ताओं के साथ संवाद करने की अनुमति देता है। प्रत्येक उपयोगकर्ता अपनी भाषा में लिखता है और अपनी भाषा में स्वचालित रूप से अनुवादित संदेश प्राप्त करता है।',
                'help.how.title': 'यह कैसे काम करता है?',
                'help.how.step1.title': 'लॉग इन करें',
                'help.how.step1.description': 'सिस्टम तक पहुंचने के लिए अपना Nick और पासवर्ड उपयोग करें। यदि आपके पास खाता नहीं है, तो यह स्वचालित रूप से बनाया जाएगा।',
                'help.how.step2.title': 'संपर्कों का अन्वेषण करें',
                'help.how.step2.description': 'सभी उपलब्ध उपयोगकर्ताओं को देखने के लिए "संपर्क" अनुभाग पर जाएं। आप नाम, देश या भाषा से खोज सकते हैं।',
                'help.how.step3.title': 'बातचीत शुरू करें',
                'help.how.step3.description': 'बातचीत शुरू करने के लिए किसी संपर्क की स्थिति या नाम पर क्लिक करें। सिस्टम स्वचालित रूप से संदेशों का अनुवाद करेगा।',
                'help.how.step4.title': 'लिखें और भेजें',
                'help.how.step4.description': 'अपनी पसंदीदा भाषा में अपना संदेश लिखें। प्राप्तकर्ता इसे अपनी भाषा में स्वचालित रूप से अनुवादित प्राप्त करेगा।',
                'help.features.title': 'मुख्य विशेषताएं',
                'help.features.translation': '🌐 भाषाओं के बीच स्वचालित और तत्काल अनुवाद',
                'help.features.status': '💬 उपस्थिति स्थिति (ऑनलाइन, निष्क्रिय, परेशान न करें, आदि)',
                'help.features.statusCustom': '💬 इमोजी और अनुकूलित संदेश के साथ अनुकूलित स्थिति',
                'help.features.contacts': '👥 खोज और फ़िल्टर के साथ पूर्ण संपर्क सूची',
                'help.features.contactsMobile': '📱 पूर्ण जानकारी (उपनाम, देश, स्थिति) के साथ अनुकूलित मोबाइल दृश्य',
                'help.features.messages': '📨 पढ़ने के संकेतक के साथ वास्तविक समय मैसेजिंग',
                'help.features.attachments': '📎 फ़ाइलें संलग्न करें: छवियां, वीडियो, ऑडियो और PDF दस्तावेज़',
                'help.features.camera': '📸 फ्रंट, रियर कैमरा या वेबकैम के साथ फोटो कैप्चर',
                'help.features.gallery': '🖼️ गैलरी से फ़ाइल चयन',
                'help.features.compression': '🗜️ स्वचालित छवि संपीड़न और थंबनेल जनरेशन',
                'help.features.progress': '📊 फ़ाइल अपलोड के दौरान प्रगति बार',
                'help.features.delete': '🗑️ अपने स्वयं के संदेशों को हटाना',
                'help.features.scroll': '⬇️ बातचीत खोलने पर अंतिम संदेश पर स्वचालित स्क्रॉल',
                'help.features.profile': '👤 अवतार, जीवनी और प्राथमिकताओं के साथ अनुकूलन योग्य प्रोफ़ाइल',
                'help.features.profileEdit': '✏️ बिना रुकावट के प्रोफ़ाइल संपादन (संपादन के दौरान अपडेट नहीं होता)',
                'help.features.countries': '🌍 195+ देशों की पूर्ण सूची और स्वचालित समय क्षेत्र चयन',
                'help.features.registration': '📧 ईमेल पुष्टि और सुरक्षा CAPTCHA के साथ पंजीकरण',
                'help.features.multilanguage': '🗣️ कई भाषाओं का समर्थन (स्पेनिश, अंग्रेजी, पुर्तगाली, फ्रेंच, जर्मन, इतालवी, रूसी, चीनी, जापानी, कोरियाई, अरबी, हिंदी)',
                'help.features.audio': '🎤 स्वचालित पाठ प्रतिलेखन के साथ आवाज संदेश रिकॉर्डिंग',
                'help.features.speechToText': '📝 Whisper और Google Speech API का उपयोग करके ऑडियो से पाठ प्रतिलेखन',
                'help.features.pwa': '📲 मोबाइल उपकरणों और डेस्कटॉप पर स्थापित करने योग्य PWA एप्लिकेशन',
                'help.features.sync': '🔄 हर 5 सेकंड में स्वचालित संदेश सिंक',
                'help.features.deleteSync': '🗑️ उपकरणों में हटाए गए संदेशों का स्वचालित सिंक',
                'help.features.notifications': '🔔 नए संदेश प्राप्त होने पर ध्वनि सूचनाएं',
                'help.features.retranslation': '🔄 यदि पहली बार विफल हो जाए तो संदेशों का स्वचालित पुन: अनुवाद',
                'help.features.preview': '👁️ भेजने से पहले फ़ाइलों का पूर्वावलोकन',
                'help.features.security': '🔒 CAPTCHA, ब्राउज़र फिंगरप्रिंट और दर सीमा के साथ सुरक्षा प्रणाली',
                'help.features.passwordRecovery': '🔑 ईमेल के माध्यम से पासवर्ड पुनर्प्राप्ति',
                'help.features.emailConfirmation': '📧 सक्रियण लिंक के साथ ईमेल के माध्यम से खाता पुष्टि',
                'help.features.invitations': '📧 निजी ईमेल आमंत्रण - परिभाषित भाषा और संदर्भ के साथ बाहरी संपर्कों को आमंत्रित करें',
                'help.features.invitationsManagement': '📋 पूर्ण आमंत्रण प्रबंधन - मेनू से लंबित आमंत्रणों को सूचीबद्ध करें, पुनः भेजें या रद्द करें',
                'help.features.contactStatus': '🏷️ दृश्यमान संपर्क स्थिति - प्रत्येक संपर्क की स्थिति देखें (लंबित, पंजीकृत, चैट के लिए तैयार)',
                'help.features.favorites': '⭐ पसंदीदा प्रणाली - त्वरित पहुंच के लिए संपर्कों को पसंदीदा के रूप में चिह्नित करें',
                'help.features.profilePhoto': '📸 बेहतर प्रोफ़ाइल फोटो अपलोड - गैलरी से छवियों का चयन करें, तत्काल पूर्वावलोकन के साथ',
                'help.features.translationSender': '👁️ प्रेषक के लिए अनुवाद दृश्य - देखें कि आपका संदेश प्राप्तकर्ता की भाषा में कैसे अनुवादित किया गया',
                'help.features.unifiedContacts': '🔗 एकीकृत संपर्क मॉडल - संपर्क आमंत्रण और मौजूदा बातचीत से प्राप्त होते हैं',
                'help.features.privacy': '🔒 डिफ़ॉल्ट रूप से निजी मोड - आपकी प्रोफ़ाइल निजी है और केवल प्रत्यक्ष आमंत्रण के माध्यम से पहुंच योग्य है',
                'help.features.export': '💾 वार्तालाप निर्यात - छवियों और फ़ाइलों के साथ पूर्ण वार्तालाप को PDF या HTML में निर्यात करें',
                'help.tips.title': 'उपयोगी सुझाव',
                'help.tips.language': '✅ सही ढंग से अनुवादित संदेश प्राप्त करने के लिए अपनी प्रोफ़ाइल में अपनी पसंदीदा भाषा सेट करें',
                'help.tips.status': '✅ दूसरों को अपनी उपलब्धता जानने के लिए अपनी उपस्थिति स्थिति अपडेट करें',
                'help.tips.statusCustom': '✅ अपनी वर्तमान स्थिति व्यक्त करने के लिए इमोजी और संदेश के साथ अनुकूलित स्थिति बनाएं',
                'help.tips.search': '✅ पसंदीदा (स्टार) चिह्नित करें और "उपयोगकर्ता" मोडल से उपयोगकर्ताओं को ब्लॉक करें',
                'help.tips.avatar': '✅ किसी संपर्क के अवतार पर क्लिक करके बड़े आकार की छवि देखें',
                'help.tips.messages': '✅ जब आपके पास अपठित संदेश हों तो ArChat® आइकन चमकता है',
                'help.tips.attachments': '✅ क्लिप बटन (📎) का उपयोग करके छवियां, वीडियो, ऑडियो या PDF संलग्न करें',
                'help.tips.camera': '✅ ऐप से सीधे फोटो कैप्चर करने के लिए कैमरा का उपयोग करें',
                'help.tips.compression': '✅ स्थान बचाने के लिए छवियां स्वचालित रूप से संपीड़ित होती हैं',
                'help.tips.delete': '✅ हटाएं बटन पर क्लिक करके अपने स्वयं के संदेशों को हटा सकते हैं',
                'help.tips.profile': '✅ चिंता किए बिना अपनी प्रोफ़ाइल संपादित करें: संपादन के दौरान सिस्टम अपडेट नहीं होता',
                'help.tips.country': '✅ समय क्षेत्र को स्वचालित रूप से कॉन्फ़िगर करने के लिए अपनी प्रोफ़ाइल में अपना देश चुनें',
                'help.tips.registration': '✅ पंजीकरण के दौरान अपने खाते को पूरी तरह से सक्रिय करने के लिए अपना ईमेल सत्यापित करें',
                'help.tips.audio': '✅ माइक्रोफोन बटन (🎤) का उपयोग करके आवाज संदेश रिकॉर्ड करें - वे स्वचालित रूप से पाठ में प्रतिलेखित हो जाएंगे',
                'help.tips.install': '✅ डेस्कटॉप से त्वरित पहुंच के लिए अपने उपकरण पर ArChat® को PWA एप्लिकेशन के रूप में स्थापित करें',
                'help.tips.sync': '✅ संदेश हर 5 सेकंड में स्वचालित रूप से सिंक होते हैं - आपको रीफ्रेश करने की आवश्यकता नहीं है',
                'help.tips.deleteSync': '✅ यदि आप एक संदेश हटाते हैं, तो यह प्राप्तकर्ता के सभी उपकरणों पर स्वचालित रूप से हटा दिया जाएगा',
                'help.tips.notifications': '✅ जब आपको किसी अन्य उपयोगकर्ता से नया संदेश मिलता है, तो आप एक ध्वनि सुनेंगे',
                'help.tips.retranslation': '✅ यदि संदेश सही ढंग से अनुवादित नहीं हुआ है, तो सिस्टम स्वचालित रूप से इसे पुन: अनुवाद करने का प्रयास करेगा',
                'help.tips.preview': '✅ यह सुनिश्चित करने के लिए भेजने से पहले फ़ाइल का पूर्वावलोकन करें कि यह सही है',
                'help.tips.passwordRecovery': '✅ यदि आप अपना पासवर्ड भूल गए हैं, तो लॉग इन करते समय "पासवर्ड भूल गए?" लिंक का उपयोग करें',
                'help.tips.emailConfirmation': '✅ पंजीकरण के बाद अपना ईमेल जांचें और पुष्टिकरण लिंक पर क्लिक करें',
                'help.tips.languageChange': '✅ किसी भी समय ध्वज चयनकर्ता से अपनी भाषा बदलें - तुरंत अपडेट',
                'help.tips.inputFixed': '✅ PC पर, अधिक सुविधा के लिए इनपुट बार स्क्रीन के निचले भाग में तय रहता है',
                'help.tips.invitations': '✅ अपनी प्रोफ़ाइल से ईमेल द्वारा संपर्कों को आमंत्रित करें - शुरुआत से भाषा और वार्तालाप मोड परिभाषित करें',
                'help.tips.invitationsManagement': '✅ "भेजे गए आमंत्रण" मेनू से अपने आमंत्रण प्रबंधित करें - ईमेल पुनः भेजें या लंबित आमंत्रण रद्द करें',
                'help.tips.contactStatus': '✅ सूची में प्रत्येक संपर्क की स्थिति देखें - लंबित (नारंगी), पंजीकृत (हरा) या सक्रिय वार्तालाप (नीला)',
                'help.tips.favorites': '✅ स्टार ⭐ के साथ संपर्कों को पसंदीदा के रूप में चिह्नित करें - पसंदीदा आपकी सूची में पहले दिखाई देंगे',
                'help.tips.profilePhoto': '✅ "गैलरी से चुनें" से अपनी प्रोफ़ाइल फोटो अपलोड करें - सहेजने से पहले आपको एक पूर्वावलोकन दिखाई देगा',
                'help.tips.translationSender': '✅ संदेश भेजते समय, अनुवाद पैनल का विस्तार करें यह देखने के लिए कि इसे प्राप्तकर्ता की भाषा में कैसे अनुवादित किया गया',
                'help.tips.unifiedContacts': '✅ जब संपर्क आमंत्रण स्वीकार करते हैं या आपके पास उनके साथ वार्तालाप होते हैं तो आपके संपर्क स्वचालित रूप से दिखाए जाते हैं',
                'help.tips.privacy': '✅ आपकी प्रोफ़ाइल डिफ़ॉल्ट रूप से निजी है - यदि आप चाहते हैं कि अन्य आपको खोजें तो प्रोफ़ाइल > गोपनीयता में सार्वजनिक दृश्यता सक्षम करें',
                'help.tips.export': '✅ हेडर में ⬇️ बटन का उपयोग करके पूर्ण वार्तालाप निर्यात करें - सभी छवियों के साथ PDF या HTML चुनें',
                'help.support.title': 'समर्थन',
                'help.support.description': 'यदि आपको समस्याएं या प्रश्न हैं, तो सिस्टम व्यवस्थापक से संपर्क करें या उपलब्ध तकनीकी दस्तावेज़ देखें।',
                'help.about.title': 'के बारे में',
                'help.about.developer': 'द्वारा विकसित:',
                'help.about.location': 'MDQ - अर्जेंटीना',
                'help.about.linkedin': 'LinkedIn प्रोफ़ाइल देखें',
                'presence.title': 'उपस्थिति स्थिति',
                'presence.currentStatus': 'वर्तमान स्थिति:',
                'presence.changeStatus': 'स्थिति बदलें',
                'presence.status.online': 'ऑनलाइन',
                'presence.status.online.title': 'ऑनलाइन - सभी के लिए दृश्यमान',
                'presence.status.online.description': 'ऑनलाइन: सभी संपर्कों के लिए दृश्यमान',
                'presence.status.idle': 'निष्क्रिय',
                'presence.status.idle.title': 'निष्क्रिय - अस्थायी अनुपस्थिति दर्शाता है',
                'presence.status.idle.description': 'निष्क्रिय: दर्शाता है कि आप अस्थायी रूप से अनुपलब्ध हैं',
                'presence.status.dnd': 'परेशान न करें',
                'presence.status.dnd.title': 'परेशान न करें - दर्शाता है कि आप बाधित नहीं होना चाहते',
                'presence.status.dnd.description': 'परेशान न करें: दृश्य संकेत कि आप बाधित नहीं होना चाहते',
                'presence.status.busy': 'व्यस्त',
                'presence.status.busy.title': 'व्यस्त - उपलब्ध नहीं',
                'presence.status.busy.description': 'व्यस्त: उपलब्ध नहीं',
                'presence.status.offline': 'ऑफलाइन',
                'presence.status.offline.title': 'डिस्कनेक्ट - ऑफलाइन के रूप में दिखाई दें',
                'presence.status.offline.description': 'ऑफलाइन: डिस्कनेक्ट के रूप में दिखाई दें',
                'presence.status.custom': 'मानक',
                'presence.status.custom.title': 'मानक - इमोजी के साथ अद्वितीय स्थिति',
                'presence.status.custom.description': 'मानक: इमोजी और वैकल्पिक समाप्ति समय के साथ अद्वितीय स्थिति',
                'dashboard.title': 'डैशबोर्ड',
                'dashboard.planUsage': 'प्लान उपयोग',
                'dashboard.filesSummary': 'मेरी फ़ाइलें',
                'dashboard.promotions': 'प्रमोशन',
                'dashboard.sessions': 'सक्रिय सत्र',
                'dashboard.explore': 'एक्सप्लोर करें',
                'dashboard.noSessions': 'कोई सक्रिय सत्र नहीं',
                'dashboard.welcomeTitle': 'ArChat® में आपका स्वागत है',
                'dashboard.welcomeSubtitle': 'किसी भी भाषा में बातचीत करें।',
                'dashboard.stepInvite': 'चरण 1: पहला संपर्क आमंत्रित करें',
                'dashboard.stepMessage': 'चरण 2: पहला संदेश भेजें',
                'dashboard.inviteContact': 'संपर्क आमंत्रित करें',
                'dashboard.exploreArChat': 'ArChat खोजें',
                'dashboard.promotionsTitle': 'प्रचार',
                'dashboard.promotionsText': 'रेफरल व पुरस्कार कार्यक्रम का सार।',
                'dashboard.viewPromotions': 'प्रचार देखें',
                'dashboard.usageTitle': 'प्लान उपयोग',
                'dashboard.sessionsTitle': 'सक्रिय सत्र',
                'dashboard.sessionsEmpty': 'कोई सक्रिय सत्र नहीं',
                'dashboard.filesTitle': 'मेरी फ़ाइलें',
                'dashboard.viewFiles': 'फ़ाइलें देखें',
                'dashboard.noBlocks': 'कोई सक्रिय ब्लॉक नहीं। कम से कम एक सेटिंग्स में चालू करें।',
                'dashboard.openSettings': 'सेटिंग्स खोलें',
                'dashboard.goToContacts': 'संपर्कों पर जाएँ',
                'dashboard.filesVisible': 'दिख रही फ़ाइलें',
                'dashboard.filesSampleNote': 'पहले पेज पर आधारित गिनती (500+ तक)।',
                'dashboard.loading': 'डेटा लोड हो रहा है...',
                'dashboard.error.title': 'त्रुटि',
                'dashboard.error.load': 'उपयोग डेटा लोड नहीं किया जा सका',
                'dashboard.error.generic': 'डैशबोर्ड लोड करने में त्रुटि',
                'dashboard.error.no_data': 'डेटा लोड नहीं किया जा सका',
                'dashboard.retry': 'पुनः प्रयास करें',
                'dashboard.unlimited': 'असीमित',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                'dashboard.card.contacts': 'संपर्क',
                'dashboard.card.chars': 'अक्षर',
                'dashboard.card.chars_month': 'इस महीने अक्षर',
                'dashboard.card.storage': 'भंडारण',
                'dashboard.card.devices': 'सक्रिय उपकरण',
                'dashboard.upgrade.title': 'अधिक संसाधनों की आवश्यकता है?',
                'dashboard.upgrade.message': 'अधिक संपर्क, अक्षर, भंडारण और सक्रिय उपकरणों के लिए अपना प्लान अपग्रेड करें।',
                'dashboard.upgrade.button': 'प्लान अपग्रेड करें',
                'upgrade.title': 'प्लान अपग्रेड करें',
                'upgrade.close': 'बंद करें',
                'upgrade.cancel': 'रद्द करें',
                'upgrade.activate': 'PRO प्लान सक्रिय करें',
                'upgrade.activating': 'सक्रिय हो रहा है...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': 'प्लान तुलना',
                'upgrade.free.label': 'मुफ्त प्लान',
                'upgrade.free.limits.contacts': 'अधिकतम 2 संपर्क',
                'upgrade.free.limits.conversations': 'अधिकतम 2 बातचीत',
                'upgrade.free.limits.no_export': 'कोई डेटा निर्यात नहीं',
                'upgrade.free.limits.no_advanced': 'कोई उन्नत सुविधाएं नहीं',
                'upgrade.pro.label': 'Pro प्लान',
                'upgrade.pro.recommended': 'अनुशंसित',
                'upgrade.pro.benefits.contacts': 'असीमित संपर्क',
                'upgrade.pro.benefits.contacts.desc': 'बिना प्रतिबंध के आवश्यक सभी संपर्क जोड़ें',
                'upgrade.pro.benefits.conversations': 'असीमित बातचीत',
                'upgrade.pro.benefits.conversations.desc': 'आवश्यक सभी सक्रिय बातचीत बनाए रखें',
                'upgrade.pro.benefits.export': 'बातचीत निर्यात',
                'upgrade.pro.benefits.export.desc': 'कई प्रारूपों (PDF, TXT, JSON) में अपनी बातचीत निर्यात करें',
                'upgrade.pro.benefits.notifications': 'उन्नत सूचनाएं',
                'upgrade.pro.benefits.notifications.desc': 'कस्टम सूचनाएं और उन्नत कॉन्फ़िगरेशन',
                'upgrade.pro.benefits.translation': 'असीमित स्वचालित अनुवाद',
                'upgrade.pro.benefits.translation.desc': 'उपयोग सीमा के बिना संदेश अनुवाद करें',
                'upgrade.pro.benefits.files': 'असीमित फ़ाइल भेजना',
                'upgrade.pro.benefits.files.desc': 'बिना प्रतिबंध के किसी भी आकार की फ़ाइलें साझा करें',
                'upgrade.pro.benefits.themes': 'कस्टम थीम',
                'upgrade.pro.benefits.themes.desc': 'सभी थीम तक पहुंच और उन्नत अनुकूलन',
                'upgrade.pro.benefits.security': 'उन्नत सुरक्षा',
                'upgrade.pro.benefits.security.desc': 'अतिरिक्त सुरक्षा और बेहतर गोपनीयता सुविधाएं',
                'upgrade.pro.benefits.analytics': 'सांख्यिकी और विश्लेषण',
                'upgrade.pro.benefits.analytics.desc': 'अपनी गतिविधि की विस्तृत सांख्यिकी तक पहुंच',
                'upgrade.pro.benefits.priority': 'प्राथमिकता समर्थन',
                'upgrade.pro.benefits.priority.desc': 'प्राथमिकता ध्यान और त्वरित प्रतिक्रिया',
                'upgrade.enterprise.label': 'Enterprise प्लान',
                'upgrade.enterprise.benefits.contacts': 'असीमित संपर्क',
                'upgrade.enterprise.benefits.support': '24/7 प्राथमिकता समर्थन',
                'upgrade.enterprise.benefits.custom': 'कस्टम समाधान',
                'upgrade.enterprise.benefits.advanced': 'उन्नत उद्यम सुविधाएं',
                'upgrade.enterprise.benefits.integration': 'कस्टम एकीकरण',
                'upgrade.enterprise.benefits.dedicated': 'समर्पित समर्थन',
                'upgrade.success.title': 'PRO प्लान सक्रिय',
                'upgrade.success.message': 'आपका प्लान PRO में अपडेट हो गया है। सभी असीमित सुविधाओं का आनंद लें।',
                'upgrade.error.title': 'PRO सक्रिय करने में त्रुटि',
                'upgrade.error.message': 'प्लान अपडेट नहीं किया जा सका। कृपया पुनः प्रयास करें।',
                'upgrade.error.generic': 'एक अप्रत्याशित त्रुटि हुई। कृपया पुनः प्रयास करें।',
                'upgrade.benefits.contacts': 'असीमित संपर्क',
                'upgrade.benefits.contacts.desc': 'बिना प्रतिबंध के आवश्यक सभी संपर्क जोड़ें',
                'upgrade.benefits.conversations': 'असीमित बातचीत',
                'upgrade.benefits.conversations.desc': 'आवश्यक सभी सक्रिय बातचीत बनाए रखें',
                'upgrade.benefits.export': 'बातचीत निर्यात',
                'upgrade.benefits.export.desc': 'कई प्रारूपों (PDF, TXT, JSON) में अपनी बातचीत निर्यात करें',
                'upgrade.benefits.notifications': 'उन्नत सूचनाएं',
                'upgrade.benefits.notifications.desc': 'कस्टम सूचनाएं और उन्नत कॉन्फ़िगरेशन',
                'upgrade.benefits.translation': 'असीमित स्वचालित अनुवाद',
                'upgrade.benefits.translation.desc': 'उपयोग सीमा के बिना संदेश अनुवाद करें',
                'upgrade.benefits.files': 'असीमित फ़ाइल भेजना',
                'upgrade.benefits.files.desc': 'बिना प्रतिबंध के किसी भी आकार की फ़ाइलें साझा करें',
                'upgrade.benefits.themes': 'कस्टम थीम',
                'upgrade.benefits.themes.desc': 'सभी थीम तक पहुंच और उन्नत अनुकूलन',
                'upgrade.benefits.security': 'उन्नत सुरक्षा',
                'upgrade.benefits.security.desc': 'अतिरिक्त सुरक्षा और बेहतर गोपनीयता सुविधाएं',
                'upgrade.benefits.analytics': 'सांख्यिकी और विश्लेषण',
                'upgrade.benefits.analytics.desc': 'अपनी गतिविधि की विस्तृत सांख्यिकी तक पहुंच',
                'upgrade.benefits.priority': 'प्राथमिकता समर्थन',
                'upgrade.benefits.priority.desc': 'प्राथमिकता ध्यान और त्वरित प्रतिक्रिया',
                'upgrade.limits.contacts': 'अधिकतम 2 संपर्क',
                'upgrade.limits.conversations': 'अधिकतम 2 बातचीत',
                'upgrade.limits.no_export': 'कोई डेटा निर्यात नहीं',
                'upgrade.limits.no_advanced': 'कोई उन्नत सुविधाएं नहीं',
                // API Error Messages
                'api.error.image_processing_not_available': 'सर्वर पर छवि प्रसंस्करण उपलब्ध नहीं है',
                'api.error.image_functions_not_available': 'छवि प्रसंस्करण कार्य उपलब्ध नहीं हैं',
                'api.error.method_not_allowed': 'विधि की अनुमति नहीं है',
                'api.error.user_not_identified': 'उपयोगकर्ता की पहचान नहीं की गई',
                'api.error.upload_file_too_large_php': 'फ़ाइल PHP द्वारा अनुमत अधिकतम आकार से अधिक है',
                'api.error.upload_file_too_large_form': 'फ़ाइल फ़ॉर्म द्वारा अनुमत अधिकतम आकार से अधिक है',
                'api.error.upload_file_partial': 'फ़ाइल आंशिक रूप से अपलोड की गई',
                'api.error.upload_no_file': 'कोई फ़ाइल अपलोड नहीं की गई',
                'api.error.upload_no_temp_dir': 'अस्थायी निर्देशिका गायब है',
                'api.error.upload_cant_write': 'डिस्क पर फ़ाइल लिखने में त्रुटि',
                'api.error.upload_extension_stopped': 'PHP एक्सटेंशन ने अपलोड रोक दिया',
                'api.error.upload_generic': 'फ़ाइल अपलोड त्रुटि',
                'api.error.file_type_not_allowed': 'फ़ाइल प्रकार की अनुमति नहीं है। केवल छवियां अनुमत हैं (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': 'फ़ाइल बहुत बड़ी है (अधिकतम 10MB)',
                'api.error.storage_limit_exceeded': 'भंडारण सीमा पार हो गई। अधिक फ़ाइलें अपलोड करने के लिए अपनी योजना अपग्रेड करें।',
                'api.error.user_not_found': 'उपयोगकर्ता नहीं मिला या निष्क्रिय',
                'api.error.image_directory_access': 'छवि निर्देशिका तक पहुंचने में त्रुटि',
                'api.error.file_extension_not_allowed': 'फ़ाइल एक्सटेंशन की अनुमति नहीं है',
                'api.error.temp_file_save': 'अस्थायी फ़ाइल सहेजने में त्रुटि',
                'api.error.image_processing': 'छवि प्रसंस्करण में त्रुटि',
                'api.error.database_update': 'डेटाबेस अपडेट करने में त्रुटि',
                'api.error.internal_server_error': 'आंतरिक सर्वर त्रुटि',
                'api.error.internal_server_error_debug': 'आंतरिक सर्वर त्रुटि',
                'api.error.user_id_required': 'उपयोगकर्ता ID आवश्यक है',
                'api.error.profile_not_found': 'प्रोफ़ाइल नहीं मिली',
                'api.error.profile_load_failed': 'प्रोफ़ाइल लोड करने में त्रुटि',
                'api.error.invalid_data': 'अमान्य डेटा',
                'api.error.validation_errors': 'सत्यापन त्रुटियां',
                'api.error.profile_update_failed': 'प्रोफ़ाइल अपडेट नहीं की जा सकी',
                'api.error.profile_update_error': 'प्रोफ़ाइल अपडेट करने में त्रुटि',
                // API Success Messages
                'api.success.photo_updated': 'फोटो अपडेट की गई',
                'api.success.profile_loaded': 'प्रोफ़ाइल सफलतापूर्वक लोड की गई',
                'api.success.profile_updated': 'प्रोफ़ाइल सफलतापूर्वक अपडेट की गई',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'डिवाइस सीमा पहुंच गई',
                'errors.deviceLimit.solution': 'जारी रखने के लिए, अन्य डिवाइस से लॉग आउट करें या अपनी योजना अपग्रेड करें।',
                // Error Messages - Network
                'errors.network.title': 'कनेक्शन त्रुटि',
                'errors.network.message': 'सर्वर से कनेक्ट नहीं हो सका। अपना इंटरनेट कनेक्शन जांचें।',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'सर्वर त्रुटि',
                'errors.server.invalidResponse.message': 'सर्वर ने अमान्य प्रतिक्रिया लौटाई। कृपया पुनः प्रयास करें।',
                // Error Messages - Generic
                'errors.generic.title': 'त्रुटि',
                'errors.generic.message': 'एक त्रुटि हुई। कृपया पुनः प्रयास करें।',
                'errors.generic.403.title': 'एक्सेस त्रुटि',
                'errors.generic.403.message': 'आपके पास इस कार्रवाई को करने की अनुमति नहीं है।',
                'errors.saas_max_users': 'योजना उपयोगकर्ता सीमा पूरी हो गई ({current}/{limit}).',
                'errors.tenant_frozen': 'टेनेंट अस्थायी रूप से अवरुद्ध है।',
                'errors.auth_invalid_credentials': 'गलत उपयोगकर्ता नाम या पासवर्ड।',
                'errors.accountInactive.title': 'खाता निष्क्रिय है। पुनः सक्रिय करने के लिए अपना ईमेल दर्ज करें।',
                'errors.accountInactive.activate': 'अभी सक्रिय करें',
                'errors.accountInactive.accept': 'स्वीकार करें',
                'errors.accountInactive.success': 'खाता पुनः सक्रिय हो गया। अब आप लॉग इन कर सकते हैं।',
                'errors.accountInactive.fail': 'खाता पुनः सक्रिय नहीं हो सका। कृपया पुनः प्रयास करें।',
                'errors.accountInactive.completeSuccess': 'आपके ईमेल से खाता सक्रिय हो गया। अब आप लॉग इन कर सकते हैं।',
                'errors.accountInactive.completeFail': 'सक्रियण पूरा नहीं हो सका। ईमेल जांचें और पुनः प्रयास करें।',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'योजना सीमा पहुंच गई',
                'plan.errors.deviceLimit.message': 'आपकी वर्तमान योजना में एक साथ जुड़े जा सकने वाले उपकरणों की संख्या पर सीमा है।',
                'plan.errors.deviceLimit.solution': 'जारी रखने के लिए, अन्य उपकरणों से लॉग आउट करें या अपनी योजना को PRO में अपग्रेड करें।',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': 'संपर्क सीमा पहुंच गई',
                'plan.errors.contactsLimit.message': 'आपकी वर्तमान योजना में आपके पास हो सकने वाले संपर्कों की संख्या पर सीमा है।',
                'plan.errors.contactsLimit.solution': 'अधिक संपर्क जोड़ने के लिए, अपनी योजना को PRO में अपग्रेड करें।',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': 'आमंत्रण सीमा पहुंच गई',
                'plan.errors.invitationsLimit.message': 'आपकी वर्तमान योजना में प्रतिदिन भेजे जा सकने वाले आमंत्रणों की संख्या पर सीमा है।',
                'plan.errors.invitationsLimit.solution': 'अधिक आमंत्रण भेजने के लिए, अपनी योजना को PRO में अपग्रेड करें।',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'संदेश सीमा पहुंच गई',
                'plan.errors.messagesLimit.message': 'आपकी वर्तमान योजना में प्रतिदिन भेजे जा सकने वाले संदेशों की संख्या पर सीमा है।',
                'plan.errors.messagesLimit.solution': 'अधिक संदेश भेजने के लिए, अपनी योजना को PRO में अपग्रेड करें।',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'भंडारण सीमा पहुंच गई',
                'plan.errors.storageLimit.message': 'आपकी वर्तमान योजना में उपलब्ध भंडारण की मात्रा पर सीमा है।',
                'plan.errors.storageLimit.solution': 'अधिक भंडारण प्राप्त करने के लिए, अपनी योजना को PRO में अपग्रेड करें।',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'योजना अपग्रेड आवश्यक',
                'plan.errors.upgradeRequired.message': 'इस सुविधा के लिए आपकी वर्तमान योजना से अधिक योजना की आवश्यकता है।',
                'plan.errors.upgradeRequired.solution': 'इस सुविधा तक पहुंचने के लिए, अपनी योजना को PRO में अपग्रेड करें।',
                "appearance.theme.system": "प्रणाली",
                "appearance.theme.corporate": "निगमित",
                "theme.system": "प्रणाली",
                "theme.corporate": "निगमित",
                'founder.title': 'FOUNDATION (संस्थापक)',
                'founder.subtitle': 'आप जीवनभर की कीमत पर शुरू से ही प्रोजेक्ट का समर्थन करते हैं।',
                'founder.whatIs': 'पहले 150 उपयोगकर्ताओं को FOUNDATION प्लान कम कीमत पर जीवनभर मिलता है।',
                'founder.howItWorks': 'आपका संस्थापक स्तर आपकी स्थिति (1 से 150) पर निर्भर करता है।',
                'founder.benefitsTitle': 'लाभ',
                'founder.benefitPrice': '$15 / माह (Founder दर)',
                'founder.benefitFeatures': 'PRO प्लान की सभी सुविधाएँ शामिल।',
                'founder.limit': 'केवल 150 संस्थापक स्थान हैं।',
                'founder.cancelRule': 'रद्द करने पर अनसब्सक्राइब रहने तक संस्थापक दर्जा खो जाता है।',
                'founder.rejoinRule': 'जगह मिलने पर आप दोबारा एक्टिव कर सकते हैं और स्वतः संस्थापक बन सकते हैं।',
                'founder.tiers.title': 'संस्थापक स्तर',
                'founder.tiers.legendary.name': 'LEGENDARY संस्थापक',
                'founder.tiers.legendary.range': 'स्थिति 1–25',
                'founder.tiers.legendary.desc': 'प्रोजेक्ट को सबसे पहले समर्थन देने वाले। सर्वोच्च ऐतिहासिक प्राथमिकता।',
                'founder.tiers.early.name': 'EARLY संस्थापक',
                'founder.tiers.early.range': 'स्थिति 26–75',
                'founder.tiers.early.desc': 'जल्दी समर्थन, विशेष मान्यता।',
                'founder.tiers.founder.name': 'संस्थापक',
                'founder.tiers.founder.range': 'स्थिति 76–150',
                'founder.tiers.founder.desc': '150 सीटों में संस्थापक स्थान।',
                'founder.whatIsLink': 'संस्थापक क्या है?',
                'founder.viewTiers': 'संस्थापक स्तर देखें',
                'founder.modalClose': 'बंद करें',
                'founder.activeCountLabel': 'सक्रिय संस्थापक',
                'founder.urgency.lastSlots': 'अंतिम Founder स्लॉट उपलब्ध',
                "founder.positionLabel": "संस्थापक #{स्थिति} / {सीमा}",
                'founder.leaderboard.title': 'टॉप संस्थापक',
                "login.email.placeholder": "Ingresa tu email para confirmar tu cuenta",
                "login.email.help": "आपके ईमेल पर एक पुष्टिकरण लिंक भेजा जाएगा",
                "auth.user_not_found": "उपयोगकर्ता नहीं मिला.",
                "auth.user_inactive": "आपका खाता निष्क्रिय कर दिया गया है. व्यवस्थापक से संपर्क करें.",
                "auth.tenant_mismatch": "आपका खाता इस परिवेश में नहीं है. व्यवस्थापक से संपर्क करें.",
                "auth.captcha_required": "आपको सुरक्षा सत्यापन (कैप्चा) पूरा करना होगा।",
                "mail.send_failed": "पुनर्प्राप्ति ईमेल नहीं भेजा जा सका. अपनी एसएमटीपी सेटिंग जांचें या बाद में पुनः प्रयास करें।",
                "auth.resend_activation": "पुन: सक्रियण ईमेल भेजें",
                "register.creatingAccount": "आपका खाता बनाया जा रहा है...",
                "common.edit": "संपादन करना",
                "common.on": "सक्रिय",
                "common.off": "अक्षम",
                "common.refresh": "अद्यतन",
                "system.processing": "प्रसंस्करण...",
                "captcha.incorrect": "कैप्चा उत्तर ग़लत है.",
                "captcha.placeholder": "जवाब लिखें",
                "captcha.questionFormat": "{ए} + {बी} क्या है?",
                'menu.admin': 'प्रशासन',
                'navbar.status': 'स्थिति',
                "navbar.users": "उपयोगकर्ताओं",
                'navbar.no_blocked_users': 'कोई अवरोधित उपयोगकर्ता नहीं',
                'navbar.blocked_users_title': 'अवरोधित उपयोगकर्ता',
                'contacts.blocked_users_title': 'अवरोधित उपयोगकर्ता',
                'contacts.country_label': 'देश',
                'contacts.not_reported': 'रिपोर्ट नहीं',
                "navbar.user_fallback": "उपयोगकर्ता पहचान}",
                "navbar.open_guide": "मार्गदर्शक",
                "help.how_archat_works": "ArChat® कैसे काम करता है",
                "help.registration": "अभिलेख",
                "help.private_invitations": "निजी निमंत्रण",
                "help.messaging": "संदेश",
                "help.security": "सुरक्षा",
                "invitation.quick_button": "संपर्क आमंत्रित करें",
                "onboarding.title": "ArChat® में आपका स्वागत है",
                "onboarding.subtitle": "किसी से भी किसी भी भाषा में संवाद करें.",
                "onboarding.step1.label": "स्टेप 1",
                "onboarding.step1.text": "अपने पहले संपर्क को आमंत्रित करें",
                "onboarding.step2.label": "चरण दो",
                "onboarding.step2.text": "अपना पहला संदेश भेजें",
                "onboarding.actions.invite": "संपर्क आमंत्रित करें",
                "onboarding.actions.explore": "ArChat® का अन्वेषण करें",
                'suggestions.sendSuccess': 'आपका सुझाव सफलतापूर्वक भेज दिया गया है।',
                'suggestions.sendError': 'सुझाव भेजा नहीं जा सका। कृपया पुनः प्रयास करें।',
                'suggestions.sent': 'सुझाव सफलतापूर्वक भेज दिया गया है।',
                'errors.suggestionSend': 'सुझाव भेजा नहीं जा सका। कृपया पुनः प्रयास करें।',
                'app.install': 'ArChat इंस्टॉल करें',
                'menu.open': 'मेनू',
                "contacts.controls.hide_non_favorites": "गैर-पसंदीदा संपर्क छिपाएँ",
                "contacts.controls.show_all": "सभी संपर्क दिखाएँ",
                "common.navigation": "मार्गदर्शन",
                "common.favorite": "पसंदीदा",
                "common.block": "अवरोध पैदा करना",
                "common.user": "उपयोगकर्ता",
                "message.new": "नया सन्देश",
                "message.edit": "संदेश संपादित करें",
                "message.edit.save": "संपादन सहेजें",
                "message.edit.cancel": "संपादन रद्द करें",
                'message.translating': 'अनुवाद हो रहा है...',
                'message.translation_failed': 'अनुवाद नहीं हो सका',
                'message.not_translated': 'मूल पाठ',
                'message.retry_send': 'पुनः प्रयास करें',
                'message.retrying': 'पुनः प्रयास हो रहा है...',
                "message.delete": "संदेश को हटाएं",
                'message.deleted_placeholder': 'संदेश हटा दिया गया',
                "message.edited": "संपादित",
                "message.edited_at": "पर संपादित",
                'message.delete_for_me.tooltip': 'मेरे लिए हटाएं',
                'message.delete_for_me.aria': 'इस संदेश को केवल मेरे लिए हटाएं',
                'message.delete_for_me.confirm_title': 'संदेश हटाएं',
                'message.delete_for_me.confirm_message': 'यह संदेश केवल आपकी स्क्रीन से हटेगा।',
                'message.delete_for_everyone.tooltip': 'सभी के लिए हटाएं',
                'message.delete_for_everyone.aria': 'इस संदेश को सभी प्रतिभागियों के लिए हटाएं',
                'message.delete_for_everyone.confirm_title': 'सभी के लिए संदेश हटाएं',
                'message.delete_for_everyone.confirm_message': 'यह संदेश आपके और दूसरे प्रतिभागी, दोनों के लिए हटेगा।',
                'message.delete_for_everyone.window_expired': 'हटाने की समय-सीमा समाप्त हो गई',
                "message.translation.show": "मूल और अनुवाद देखें",
                "message.translation.hide": "अनुवाद छिपाएँ",
                "emoji.search": "इमोजी खोजें",
                "emoji.close": "चयनकर्ता बंद करें",
                "captcha.refresh": "कैप्चा पुन: उत्पन्न करें",
                'presence.unavailable': 'Status upalabdh nahi hain',
                'presence.maintenance': 'Server maintenance mein hai',
                "home.access_nav": "एप्लिकेशन तक पहुंच",
                "common.requiredFields": "सभी आवश्यक फ़ील्ड पूर्ण करें.",
                "bio.view": "जीवनी देखें",
                "profile.nick.readonly": "उपयोगकर्ता नाम संशोधित नहीं किया जा सकता",
                "profile.nick.readonly.help": "उपयोगकर्ता नाम अद्वितीय है और उसे संशोधित नहीं किया जा सकता",
                "profile.email.readonly": "ईमेल को संशोधित नहीं किया जा सकता",
                "profile.email.readonly.help": "ईमेल अद्वितीय है और इसे संशोधित नहीं किया जा सकता",
                "profile.invitations.title": "आमंत्रण",
                "profile.invitations.validated": "मान्य निमंत्रण",
                "profile.invitations.nextBadge": "अगली उपलब्धि",
                "profile.invitations.progress": "प्रगति",
                "profile.invitations.achievement": "उपलब्धि",
                "profile.invitations.topInviterAchieved": "अधिकतम आमंत्रणकर्ता तक पहुंच गया",
                "profile.invitations.badges.networkBuilder": "नेटवर्क बिल्डर",
                "profile.invitations.badges.topInviter": "अधिकतम निमंत्रक",
                "profile.invitations.achievement.networkBuilderMessage": "आपने ArChat पर 20 उपयोगकर्ताओं को आमंत्रित किया।",
                "profile.invitations.achievement.topInviterMessage": "आपने ArChat पर 50 उपयोगकर्ताओं को आमंत्रित किया।",
                "profile.plan.loading_info": "योजना की जानकारी लोड हो रही है...",
                "profile.plan.valid_until": "तब तक वैध:",
                "profile.plan.active_since": "से सक्रिय हैं:",
                "profile.plan.active_badge": "✓ सक्रिय",
                "profile.manage_plan": "योजना प्रबंधित करें",
                "plan.current_plan": "वर्तमान योजना",
                "plan.current": "Actual",
                'plan.footer_prefix': 'योजना:',
                "plan.upgrade_to_pro": "प्रो में अपग्रेड",
                "plan.upgrade_to_foundation": "फ़ाउंडेशन में अपग्रेड करें",
                "plan.payment_coming": "पैडल से भुगतान जल्द ही उपलब्ध होगा। आप यहां से योजनाएं बदल सकते हैं.",
                "plan.payment_coming_title": "जल्द ही",
                "plan.foundation_full": "फाउंडेशन कोटा पूरा हो गया है (150 संस्थापक)। आप PRO चुन सकते हैं.",
                "plan.sold_out": "थका हुआ",
                "plan.founder_spots_remaining": "केवल {गिनती} स्थान उपलब्ध हैं",
                "plan.founders_occupied": "व्यस्त संस्थापक",
                "plan.upgrade_not_allowed": "केवल मुफ़्त योजना वाले उपयोगकर्ता ही अपग्रेड का अनुरोध कर सकते हैं।",
                "plan.free_contacts": "Hasta 2 contactos",
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "संपर्क",
                "billing.usage.chars_month": "प्रति माह वर्ण",
                "billing.usage.storage": "प्रयुक्त भंडारण",
                "billing.usage.devices": "जुड़ी हुई डिवाइसेज",
                "billing.loading": "चार्ज हो रहा है...",
                'billing.subscription.section_title': 'सदस्यता और बिलिंग',
                'billing.subscription.provider_note': 'प्रदाता',
                'billing.subscription.paddle_active': 'Paddle (ऐप में सक्रिय प्लान)',
                'billing.subscription.mp_action_ok': 'अनुरोध दर्ज किया गया। यदि चेकआउट नहीं खुला, कनेक्शन जाँचें या पुनः प्रयास करें।',
                'billing.paddle.manage_subscription_button': 'सदस्यता प्रबंधित करें',
                'billing.paddle.portal_confirm_title': 'बिलिंग पोर्टल',
                'billing.paddle.portal_confirm': 'सुरक्षित Paddle पोर्टल खुलेगा—भुगतान विधि, चालान अपडेट करने या सदस्यता रद्द करने के लिए। जारी रखें?',
                'billing.paddle.portal_opened_hint': 'Paddle पोर्टल नए टैब में खुला। यदि प्लान अपडेट नहीं हुआ तो प्रोफ़ाइल रिफ्रेश करें।',
                'billing.paddle.portal_error': 'Paddle पोर्टल नहीं खुल सका। बाद में पुनः प्रयास करें या सहायता से संपर्क करें।',
                'billing.paddle.no_link_error': 'आपके खाते पर अभी तक Paddle सदस्यता लिंक नहीं है। अभी भुगतान किया है तो webhook की प्रतीक्षा करें या सहायता से संपर्क करें।',
                'billing.paddle.api_not_configured': 'सर्वर पर Paddle API कॉन्फ़िगरेशन (PADDLE_API_KEY) नहीं है। प्रशासक को सेट करना होगा।',
                "billing.descriptions.contacts": "आपके खाते में संग्रहीत कुल संपर्क",
                "billing.descriptions.storage": "फ़ाइलों और मीडिया के लिए उपयोग किया जाने वाला संग्रहण",
                "billing.descriptions.chars_month": "इस माह पात्रों का अनुवाद किया गया",
                "billing.descriptions.devices": "सक्रिय कनेक्टेड डिवाइस",
                'billing.paddle.return_title': 'भुगतान प्राप्त हुआ',
                'billing.paddle.return_body': 'यदि आपने चेकआउट पूरा किया है, Paddle पुष्टि के बाद जल्द ही प्लान अपडेट होगा। आप होम पर लौट सकते हैं।',
                'billing.paddle.verifying': 'आपका प्लान जाँचा जा रहा है…',
                'billing.paddle.not_logged_in': 'अपडेटेड प्लान स्थिति देखने के लिए साइन इन करें।',
                'billing.paddle.plan_updated': 'प्लान सफलतापूर्वक अपडेट: {plan}',
                'billing.paddle.plan_current': 'आपका वर्तमान प्लान: {plan}',
                'billing.paddle.plan_current_founder': 'अब आप Founder हैं — {plan}',
                'billing.paddle.still_free_hint': 'कुछ क्षण बाद भी FREE दिखे तो webhook में देरी हो सकती है। बैकएंड लॉग देखें या पृष्ठ रिफ्रेश करें।',
                'billing.paddle.pro_extra_hint': 'प्लान उपयोग करने के लिए होम पर लौट सकते हैं।',
                "attachment.audioNotSupported": "ArChat® में ऑडियो संदेश समर्थित नहीं हैं। कृपया एक लिखित संदेश भेजें.",
                "message.audioDeprecated.title": "ध्वनि संदेश समर्थित नहीं है",
                "message.audioDeprecated.message": "यह ध्वनि संदेश अब ArChat® द्वारा समर्थित नहीं है। कृपया एक लिखित संदेश भेजें.",
                "profile.photo.select": "फ़ोटो चुनें",
                "profile.photo.select.gallery": "गैलरी से चयन करो",
                "avatar.errors.too_large": "छवि बहुत बड़ी है. अधिकतम आकार: 2 एमबी.",
                "avatar.preview.title": "अवतार पूर्वावलोकन",
                "profile.avatar.error_title": "अवतार अपडेट नहीं किया जा सका",
                "profile.avatar.error.title": "अवतार अपडेट नहीं किया जा सका",
                "profile.avatar.error.size": "छवि अनुमत आकार से अधिक है. अधिकतम 2 एमबी है.",
                "profile.avatar.tooLarge.title": "छवि बहुत बड़ी है",
                "profile.avatar.tooLarge.message": "फ़ोटो अनुमत आकार से अधिक है. अधिकतम 2 एमबी है.",
                "profile.avatar.uploadError.title": "अवतार अपडेट नहीं किया जा सका",
                "profile.avatar.uploadError.message": "छवि अपलोड करने में एक समस्या थी. पुनः प्रयास करें।",
                "profile.saveSuccess.title": "अद्यतन प्रोफ़ाइल",
                "profile.saveSuccess.message": "आपके परिवर्तन सफलतापूर्वक सहेजे गए.",
                "profile.avatar.file_too_large": "छवि अनुमत अधिकतम आकार (2 एमबी) से अधिक है।",
                "profile.avatar.file_too_large_hint": "एक हल्की छवि चुनें या उसका आकार कम करें और पुनः प्रयास करें।",
                "profile.photo.take.front": "सामने का कैमरा",
                "profile.photo.take.back": "पीछे का कैमरा",
                "profile.photo.take.webcam": "वेबकैम",
                "profile.photo.camera.front": "सामने का कैमरा",
                "profile.photo.camera.back": "पीछे का कैमरा",
                "profile.photo.camera.web": "वेबकैम",
                "profile.photo.close": "बंद करना",
                "profile.photo.capture": "कब्जा",
                "block.toggle_error": "लॉक या अनलॉक नहीं किया जा सका.",
                "contact.favorite.add": "पसंदीदा में जोड़े",
                "contact.favorite.remove": "पसंदीदा से हटाएँ",
                "contact.block.block": "अवरोध पैदा करना",
                'contact.block.unblock': 'अनब्लॉक करें',
                "conversation.notFound": "बातचीत नहीं मिली",
                "help.howWorks.title": "👥 ArChat® कैसे काम करता है (वास्तविक प्रवाह)",
                "help.howWorks.step1.title": "1️⃣ पंजीकरण",
                "help.howWorks.step1.point1": "अपने उपनाम और पासवर्ड से लॉग इन करें।",
                "help.howWorks.step1.point2": "यदि आपके पास कोई खाता नहीं है, तो यह स्वचालित रूप से बनाया जाता है।",
                "help.howWorks.step1.point3": "आप अपनी भाषा में नियम और शर्तें स्वीकार करते हैं।",
                "help.howWorks.step1.point4": "आप ईमेल द्वारा अपने खाते की पुष्टि करें.",
                "help.howWorks.step2.title": "2️⃣ निजी निमंत्रण",
                "help.howWorks.step2.point1": "अपनी प्रोफ़ाइल से ईमेल द्वारा संपर्कों को आमंत्रित करें.",
                "help.howWorks.step2.point2": "शुरू करने से पहले भाषा और बातचीत के तरीके को परिभाषित करें।",
                "help.howWorks.step2.point3": "संपर्क को एक निजी निमंत्रण प्राप्त होता है.",
                "help.howWorks.step2.point4": "आप देख सकते हैं कि क्या यह है: लंबित, पंजीकृत, चैट करने के लिए तैयार",
                "help.howWorks.step2.point5": "संपर्क मांगे नहीं जाते, उन्हें आमंत्रित किया जाता है.",
                "help.howWorks.step2.point6": "संपर्क मांगे नहीं जाते, उन्हें आमंत्रित किया जाता है.",
                "help.howWorks.step3.title": "3️⃣ संपर्क और बातचीत",
                "help.howWorks.step3.point1": "आपके संपर्क स्वचालित रूप से तब प्रकट होते हैं जब:",
                "help.howWorks.step3.point2": "निमंत्रण स्वीकार करें",
                "help.howWorks.step3.point3": "या बातचीत होती है",
                "help.howWorks.step3.point4": "कर सकना:",
                "help.howWorks.step3.point5": "उन्हें पसंदीदा के रूप में चिह्नित करें ⭐",
                "help.howWorks.step3.point6": "उन्हें कस्टम उपनाम निर्दिष्ट करें",
                "help.howWorks.step3.point7": "निजी नोट्स जोड़ें",
                "help.howWorks.step3.point8": "उन्हें ब्लॉक करें या प्रबंधित करें",
                "help.howWorks.step3.point9": "सहमति के बिना कोई सार्वजनिक एजेंडा या दृश्यमान उपयोगकर्ता नहीं है।",
                "help.howWorks.step4.title": "4️⃣ अनुवाद के साथ संदेश भेजना",
                "help.howWorks.step4.point1": "हमेशा अपनी भाषा में लिखें.",
                "help.howWorks.step4.point2": "सिस्टम स्वचालित रूप से संदेश का अनुवाद करता है।",
                "help.howWorks.step4.point3": "प्राप्तकर्ता इसे अपनी भाषा में प्राप्त करता है।",
                "help.howWorks.step4.point4": "आप लागू किए गए अनुवाद को देख सकते हैं.",
                "help.howWorks.step4.point5": "यदि कोई अनुवाद विफल हो जाता है, तो उसे स्वचालित रूप से पुनः प्रयास किया जाता है।",
                "help.howWorks.step4.point6": "ArChat® केवल गति को नहीं, बल्कि स्पष्टता और अर्थ को प्राथमिकता देता है।",
                "help.privacy.title": "🔒 गोपनीयता और नियंत्रण",
                "help.privacy.point1": "आपकी प्रोफ़ाइल डिफ़ॉल्ट रूप से निजी है.",
                "help.privacy.point2": "केवल वे लोग जिन्हें आपने आमंत्रित किया है, वे ही आपको देख सकते हैं या आपको लिख सकते हैं।",
                "help.privacy.point3": "सार्वजनिक दृश्यता वैकल्पिक है और डिफ़ॉल्ट रूप से अक्षम है।",
                "help.privacy.point4": "सक्रिय सुरक्षा के साथ:",
                "help.privacy.point5": "कॅप्चा",
                "help.privacy.point6": "दर सीमित करना",
                "help.privacy.point7": "अंगुली की छाप",
                "help.privacy.point8": "ईमेल सत्यापन",
                "help.privacy.point9": "आपकी बातचीत सार्वजनिक या अनुक्रमित नहीं हैं.",
                "help.files.title": "📎 फ़ाइलें और निर्यात",
                "help.files.point1": "चित्र, वीडियो और पीडीएफ दस्तावेज़ संलग्न करें।",
                "help.files.point2": "फ्रंट कैमरे, रियर कैमरे या वेबकैम से तस्वीरें खींचें।",
                "help.files.point3": "छवियाँ स्वचालित रूप से संपीड़ित होती हैं.",
                "help.files.point4": "भेजने से पहले पूर्वावलोकन करें.",
                "help.files.point5": "लोडिंग के दौरान प्रगति पट्टी.",
                "help.files.point6": "संपूर्ण वार्तालाप यहां निर्यात करें:",
                "help.files.point7": "पीडीएफ",
                "help.files.point8": "एचटीएमएल",
                "help.files.point9": "संदेश, चित्र और फ़ाइलें शामिल हैं।",
                "help.files.point10": "आपका डेटा आपका है.",
                "help.experience.title": "🎨उपयोगकर्ता अनुभव",
                "help.experience.point1": "इमोजी के साथ उपस्थिति स्थितियाँ और कस्टम स्थितियाँ।",
                "help.experience.point2": "एकीकृत ओपनमोजी इमोजी।",
                "help.experience.point3": "संकेतक पढ़ें और लिखें.",
                "help.experience.point4": "डेस्कटॉप के बराबर अनुकूलित मोबाइल दृश्य।",
                "help.experience.point5": "इंस्टाल करने योग्य PWA एप्लिकेशन.",
                "help.experience.point6": "दो थीम: अर्जेंटीना (हल्का नीला/सफ़ेद/सुनहरा) और ऑस्कुरो (गहरा बैंगनी)।",
                "help.experience.point7": "शीतल पेय के बिना प्रोफ़ाइल संपादन।",
                "help.experience.point8": "स्वचालित समय क्षेत्र के साथ देश चयनकर्ता।",
                "help.experience.point9": "पसंदीदा, खोज और फ़िल्टर के साथ त्वरित पहुँच।",
                "help.languages.title": "🌍 भाषाएँ",
                "help.languages.point1": "{गिनती} भाषाओं के लिए समर्थन।",
                "help.languages.point2": "झंडे के साथ दृश्य चयनकर्ता.",
                "help.languages.point3": "इंटरफ़ेस, नियम एवं शर्तें और ईमेल चुनी गई भाषा के अनुसार अनुकूलित।",
                "help.languages.point4": "उपयोगकर्ताओं के बीच दो-तरफा स्वचालित अनुवाद।",
                "help.tipsNew.title": "ArChat® का लाभ उठाने के लिए युक्तियाँ",
                "help.tipsNew.point1": "केवल उन्हीं लोगों को आमंत्रित करें जिनके साथ आप वास्तव में संवाद करना चाहते हैं।",
                "help.tipsNew.point2": "संपर्कों को व्यवस्थित करने के लिए उपनाम और निजी नोट्स का उपयोग करें।",
                "help.tipsNew.point3": "त्वरित पहुंच के लिए पसंदीदा चिह्नित करें।",
                "help.tipsNew.point4": "महत्वपूर्ण संदेश भेजने से पहले अनुवाद की जाँच करें।",
                "help.tipsNew.point5": "बैकअप या कार्य के लिए प्रासंगिक वार्तालाप निर्यात करें।",
                "help.tipsNew.point6": "जब लिखित स्पष्टता महत्वपूर्ण हो तो ArChat® का उपयोग करें।",
                "help.whySubscribe.title": "🚀 ArChat® की सदस्यता क्यों लें",
                "help.whySubscribe.point1": "ArChat® को किसी के साथ चैट करने के लिए डिज़ाइन नहीं किया गया है,",
                "help.whySubscribe.point2": "लेकिन उन लोगों के साथ बेहतर संवाद करना जो मायने रखते हैं।",
                "help.whySubscribe.point3": "अगर आपको चाहिये:",
                "help.whySubscribe.point4": "भाषाओं के बीच स्पष्टता",
                "help.whySubscribe.point5": "वास्तविक गोपनीयता",
                "help.whySubscribe.point6": "संपर्क नियंत्रण",
                "help.whySubscribe.point7": "वार्तालाप निर्यात",
                "help.whySubscribe.point8": "एक पेशेवर और शोर-मुक्त अनुभव",
                "help.whySubscribe.point9": "ArChat® उसी के लिए डिज़ाइन किया गया है।",
                "help.features.contactsFilter": "👁️ गैर-पसंदीदा संपर्क बटन दिखाएं/छिपाएं - सूची को केवल अपने पसंदीदा तक सीमित करें",
                "help.features.contactAlias": "✏️ प्रत्येक संपर्क के लिए कस्टम उपनाम और निजी नोट्स - बातचीत में संपर्क नाम पर क्लिक करें",
                "help.features.themes": "🎨 दो थीम उपलब्ध हैं: अर्जेंटीना (हल्का नीला/सफ़ेद/सुनहरा) और ऑस्कुरो (गहरा बैंगनी)",
                "help.tips.contactsFilter": "✅ गैर-पसंदीदा संपर्कों को दिखाने या छिपाने के लिए शीर्ष बार में आई बटन (👁️) का उपयोग करें",
                "help.tips.contactAlias": "✅ कस्टम उपनाम और निजी नोट्स जोड़ने के लिए बातचीत में संपर्क नाम पर क्लिक करें",
                "help.tips.themes": "✅ सेटिंग्स> उपस्थिति से थीम बदलें: अर्जेंटीना (हल्का नीला) या गहरा (गहरा बैंगनी)",
                "help.message_time_context.title": "संदेशों का अस्थायी संदर्भ",
                "help.message_time_context.description": "प्रत्येक संदेश भेजने के समय प्रेषक का स्थानीय समय, समय क्षेत्र और देश सहेज सकता है। इस तरह आप देख सकते हैं कि दूसरे यूजर ने कहां और किस समय भेजा है।",
                "help.message_time_context.point1": "मुफ़्त योजना में, केवल आपके समय क्षेत्र (रिसीवर) का समय दिखाया जाता है।",
                "help.message_time_context.point2": "PRO योजना में, जारीकर्ता का स्थानीय समय, देश और समय क्षेत्र भी दिखाया जाता है।",
                "help.message_time_context.point3": "प्रत्येक संदेश में संदर्भ ऐतिहासिक रूप से सहेजा जाता है।",
                "help.message_time_context.point4": "उच्च योजनाओं पर उन्नत ऑडिटिंग सुविधाएँ उपलब्ध हैं।",
                "help.tips.writing": "✅ स्पष्ट संदेश लिखें: ArChat® संदर्भ और स्पष्टता बनाए रखते हुए लिखित पाठ के अर्थ का अनुवाद करता है",
                'presence.custom.title': 'Niji sthiti',
                'presence.custom.status': 'Niji sthiti',
                'presence.custom.placeholder': 'Udaharan: Chai pee raha hun ☕',
                'presence.custom.emoji': 'Emoji (vaikalpik)',
                'presence.custom.emojiHelp': 'Emoji chunen ya likhen',
                'presence.custom.temporary': 'Asthayi sthiti (apne aap samaapt hogi)',
                'presence.custom.expiration': 'Samaapti tithi',
                'presence.custom.expirationHelp': 'Samaapt hone par sthiti "Online" par laut aayegi',
                'presence.custom.suggestions': 'Sujhav',
                'presence.custom.preview': 'Purvavalokan',
                'presence.custom.save': 'Sthiti sahejen',
                'presence.custom.required': 'Niji sthiti aavashyak hai',
                'presence.custom.maxLength': 'Adhiktam 64 akshar',
                'presence.custom.expirationRequired': 'Aapko samaapti tithi chunni hogi',
                'presence.custom.expirationFuture': 'Samaapti tithi bhavishya mein honi chahiye',
                'presence.custom.selectEmoji': 'Emoji chunen',
                "invitation.success.title": "निमंत्रण भेजा गया",
                "invitation.success.message": "निमंत्रण सफलतापूर्वक भेजा गया।\\n\\nसंपर्क को निमंत्रण स्वीकार करने के लिए एक लिंक के साथ एक ईमेल प्राप्त होगा। एक बार स्वीकार कर लेने के बाद, आप उससे चैट करना शुरू कर सकते हैं।",
                "invitation.top.title": "शीर्ष नेटवर्क बिल्डर्स",
                "invitation.top.invitesSuffix": "आमंत्रण",
                "invitation.ranking.position": "पद",
                "invitation.ranking.user": "उपयोगकर्ता",
                "invitation.ranking.validatedInvites": "मान्य निमंत्रण",
                "invitation.ranking.empty": "प्रदर्शित करने के लिए कोई मान्य आमंत्रण नहीं हैं.",
                "invitation.ranking.loading": "रैंकिंग लोड हो रही है...",
                "invitation.ranking.loadError": "रैंकिंग लोड नहीं की जा सकी.",
                "invitations.waitBeforeResend": "आप अभी तक आमंत्रण दोबारा नहीं भेज सकते. अतिथि उपयोगकर्ता को स्पैमिंग से बचने के लिए आपको प्रत्येक भेजने के बीच 10 मिनट तक प्रतीक्षा करनी होगी।",
                "invitations.captchaQuestion": "%1 + %2 कितना है?",
                "invitations.resendSuccess": "आमंत्रण सफलतापूर्वक अग्रेषित किया गया.",
                "invitations.dailyLimit": "आप आज पुनः सबमिशन की अधिकतम अनुमत सीमा तक पहुंच गए हैं।",
                "invitations.invalidEmail": "मेल सर्वर ने बताया कि यह पता अमान्य है।",
                "achievement.unlocked": "खुली उपलब्धि",
                "achievement.continue": "जारी रखना",
                'dashboard.not_available': 'उपलब्ध नहीं',
                "plan.errors.chatsLimit.title": "बातचीत की सीमा पूरी हो गई",
                "plan.errors.chatsLimit.message": "आपकी वर्तमान योजना में आपके द्वारा की जाने वाली बातचीत की संख्या की एक सीमा है।",
                "plan.errors.chatsLimit.solution": "अधिक वार्तालाप बनाने के लिए, अपनी योजना को PRO में अपग्रेड करें।",
                "errors.generic": "एक अप्रत्याशित त्रुटि हुई। पुनः प्रयास करें।",
                "errors.modal.title": "गलती",
                "errors.modal.copyDetails": "विवरण कॉपी करें",
                "errors.modal.close": "बंद करना",
                "errors.modal.reportSupport": "समर्थन के लिए रिपोर्ट करें",
                "errors.avatarTooLarge": "छवि 2एमबी के अनुमत आकार से अधिक है।",
                "errors.avatarTooLarge.title": "छवि बहुत बड़ी है",
                "errors.avatarTooLarge.message": "छवि 2एमबी के अनुमत आकार से अधिक है।",
                "errors.invalidImageType": "चयनित फ़ाइल मान्य छवि नहीं है.",
                "errors.invalidImageType.title": "अमान्य लेख्यपत्र",
                "errors.invalidImageType.message": "चयनित फ़ाइल मान्य छवि नहीं है.",
                "errors.uploadFailed": "छवि अपलोड नहीं की जा सकी. पुनः प्रयास करें।",
                "errors.uploadFailed.title": "अपलोड करने में त्रुटि",
                "errors.uploadFailed.message": "छवि अपलोड नहीं की जा सकी. पुनः प्रयास करें।",
                "errors.conversationCreate": "वार्तालाप बनाने में त्रुटि. कृपया पुन: प्रयास करें।",
                "errors.conversationInvalidId": "अमान्य वार्तालाप आईडी.",
                "errors.conversationOpen": "वार्तालाप खोलने में त्रुटि. कृपया पुन: प्रयास करें।",
                "errors.favoriteUpdate": "पसंदीदा अपडेट करने में विफल",
                "errors.blockUpdate": "लॉक अपडेट नहीं किया जा सका",
                "errors.messageEdit": "संदेश संपादित करने में त्रुटि.",
                "errors.foundation_sold_out": "संस्थापक स्थान बिक चुके हैं।",
                "errors.unexpected_error": "एक अप्रत्याशित त्रुटि हुई। पुनः प्रयास करें।",
                "errors.userInactive.title": "निष्क्रिय खाता",
                "errors.tenantMismatch.title": "किरायेदार त्रुटि",
                'auth.tagline': 'भाषा की परवाह किए बिना समझे जाने की शक्ति',
                'auth.sign_in': 'लॉग इन करें',
                'auth.create_account': 'खाता बनाएं',
                'ui.search_contact': 'संपर्क खोजें...',
                'ui.language': 'भाषा',
                'profile.my_profile': 'मेरी प्रोफ़ाइल',
                'profile.status': 'स्थिति',
                'profile.invite_email': 'ईमेल द्वारा संपर्क आमंत्रित करें',
                'profile.sent_invitations': 'भेजे गए आमंत्रण',
                "profile.users": "उपयोगकर्ताओं",
                'profile.settings': 'सेटिंग्स',
                'profile.appearance': 'दिखावट',
                'profile.logout': 'लॉग आउट',
                'contacts.mode': 'मोड',
                'contacts.sent': 'भेजा गया',
                'contacts.actions': 'कार्रवाई',
                'contacts.pending': 'लंबित',
                'contacts.available': 'उपलब्ध',
                'contacts.invited_registered': 'आमंत्रित - पंजीकृत',
                'table.email': 'ईमेल',
                'table.language': 'भाषा',
                'table.mode': 'मोड',
                'table.status': 'स्थिति',
                'table.sent': 'भेजा गया',
                'table.actions': 'कार्रवाई',
  'promotions.invite.message': 'मैं आपको ArChat पर आमंत्रित करता हूं - किसी भी भाषा में बात करें। हम दोनों को लाभ मिलता है।',
  'promotions.progress.pending': 'आपके पास पुरस्कार अनलॉक करने के लिए निमंत्रण लंबित हैं।',
  'promotions.progress.in_progress': 'आपके निमंत्रण प्रगति पर हैं: वास्तविक बातचीत के बाद पुरस्कार सक्रिय हो जाते हैं।',
  'promotions.progress.remaining': 'आपको अपना पुरस्कार प्राप्त करने के लिए अधिक बातचीत की आवश्यकता है।',
  'promotions.progress.sent_count': 'भेजा',
  'promotions.progress.pending_count': 'लंबित',
  'promotions.progress.in_progress_count': 'प्रगति पर है',
  'promotions.progress.completed_count': 'पुरा होना।',
  'promotions.banner.empty': 'अभी शुरू करें: संपर्कों को आमंत्रित करें और लाभ अनलॉक करें।',
  'promotions.banner.pending': 'आपके पास लंबित निमंत्रण हैं: वास्तविक वार्तालाप पूरा करें और पुरस्कार अर्जित करें।',
  'promotions.banner.reward': 'आपने पहले ही पुरस्कार अनलॉक कर दिए हैं! अपना लाभ बढ़ाने के लिए आमंत्रित करते रहें।',
  'promotions.cta.copy': 'संदेश और लिंक कॉपी करें',
  'promotions.cta.copied': 'संदेश कॉपी किया गया',
  'promotions.cta.copy_error': 'संदेश कॉपी नहीं किया जा सका',

  'promotions.title': 'पदोन्नति और पुरस्कार',
  'promotions.subtitle': 'संपर्कों को आमंत्रित करें और वास्तविक उपयोग के माध्यम से लाभ अनलॉक करें।',
  'promotions.how_it_works': 'यह काम किस प्रकार करता है',
  'promotions.step1': 'अपनी प्रोफ़ाइल से किसी संपर्क को आमंत्रित करें.',
  'promotions.step2': 'जब वे वास्तविक बातचीत को स्वीकार करते हैं और चैट करते हैं, तो यह स्वचालित रूप से मान्य हो जाता है।',
  'promotions.step3': 'पुरस्कार जमा कर दिया जाता है और आपकी प्रगति अपडेट कर दी जाती है।',
  'promotions.rewards.title': 'पुरस्कार',
  'promotions.reward.invite': 'प्रत्येक मान्य रेफरल के लिए इनाम।',
  'promotions.reward.milestone': 'विकास मील के पत्थर के लिए बोनस.',
  'promotions.reward.ranking': 'शीर्ष नेटवर्क बिल्डर्स रैंकिंग में दृश्यता।',
  'promotions.progress.title': 'आपकी प्रगति',
  'promotions.progress.sent': 'भेजा',
  'promotions.cta.invite': 'संपर्क आमंत्रित करें',
  'promotions.banner': 'प्रचार सक्रिय करें: वास्तविक उपयोग के लिए आमंत्रित करें और पुरस्कार अर्जित करें।',
  'promotions.modal.title': 'प्रचार कार्यक्रम',
  'promotions.modal.body': 'प्रति मान्य निमंत्रण +10.000 अक्षर अर्जित करें।\\nआज ही आमंत्रित करें और पुरस्कार अनलॉक करें।',
  'promotions.modal.cta': 'प्रमोशन देखें',
                "app.install_ios_hint": "स्थापित करने के लिए: साझा करें > होम स्क्रीन पर जोड़ें",
                'menu.promotions': 'प्रमोशन',
                "suggestions.new": "नया सुझाव",
                "suggestions.empty": "आपने अभी तक कोई सुझाव सबमिट नहीं किया है.",
                "suggestions.admin_note": "टीम नोट",
                "suggestions.status.pending": "कान की बाली",
                "suggestions.status.reviewed": "संशोधित",
                "suggestions.status.planned": "की योजना बनाई",
                "suggestions.status.implemented": "कार्यान्वित",
                "suggestions.status.rejected": "अस्वीकार कर दिया",
                "referral.promo": "आमंत्रित करें और 10,000 अक्षर जीतें",
                "referral.stats.sent": "भेजा",
                "referral.stats.accepted": "स्वीकृत",
                "referral.stats.rewards": "पुरस्कार",
                "referral.reward.pending": "कान की बाली",
                "referral.reward.granted": "भरा हुआ",
                "referral.reward.invalid": "अमान्य",
                "referral.reward.in_progress": "उपयोग में",
                "referral.limit.reached": "इनाम की सीमा पूरी हो गई",
                "referral.waiting.usage": "जब आप और आपका अतिथि एक ही चैट में कम से कम एक वास्तविक टेक्स्ट संदेश भेजते हैं (सर्वर-मान्य) तो प्रत्येक में +10,000 अक्षर।",
                "common.avatar": "अवतार",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": "अब तक कोई संदेश नहीं है",
                "messages.loading": "संदेश लोड हो रहे हैं...",
                "messages.connecting_server": "संदेश सर्वर से कनेक्ट हो रहा है...",
                "messages.pending_send_count": "{गिनती} संदेश डिलीवरी की प्रतीक्षा में है",
                "presence.custom.suggestion.coffee": "कुछ साथी होना ☕",
                "presence.custom.suggestion.soccer": "कोर्ट पर ⚽",
                "presence.custom.suggestion.working": "पागलों की तरह काम करना 💪",
                "presence.custom.suggestion.lunch": "दोपहर का भोजन कर रहे हैं 🍽️",
                "presence.custom.suggestion.family": "पारिवारिक दोपहर का भोजन 👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "पढ़ाई 📚",
                "presence.custom.suggestion.travel": "एक यात्रा पर ✈️",
                "presence.custom.suggestion.meeting": "मुलाकात में 💼",
                "presence.custom.suggestion.resting": "आराम कर रहे हैं 😴",
                "presence.custom.suggestion.gaming": "वीडियो गेम खेलना 🎮",
                "presence.custom.suggestion.reading": "पढ़ना 📖",
                "presence.custom.suggestion.offlineSoon": "मैं अभी वापस आऊंगा ⏳",
                "invitation.safe.phase_notice": "सक्रिय सुरक्षित चरण: वाणिज्यिक सक्रियण के लंबित लाभ (सीमाओं पर कोई वास्तविक प्रभाव नहीं)।",
                "invitation.safe.generate_code": "लिंक/कोड जनरेट करें",
                "invitation.safe.refresh_top3": "अद्यतन शीर्ष 3",
                "invitation.safe.top_loading": "शीर्ष आमंत्रणकर्ता लोड हो रहे हैं...",
                "invitation.safe.top_empty": "अभी तक कोई विशेष आमंत्रित व्यक्ति नहीं हैं।",
                "invitation.safe.hide_full_ranking": "पूरी रैंकिंग छिपाएँ",
                "invitation.safe.view_full_ranking": "पूरी रैंकिंग देखें",
                "invitation.safe.hide_metrics_dashboard": "मेट्रिक्स डैशबोर्ड छिपाएँ",
                "invitation.safe.view_metrics_dashboard": "मेट्रिक्स डैशबोर्ड देखें",
                "invitation.safe.prepared_link": "लिंक तैयार",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "लंबित आमंत्रण रजिस्टर करें",
                "invitation.safe.status_summary": "स्थिति सारांश",
                "invitation.safe.summary.pending": "झुमके",
                "invitation.safe.summary.registered": "दर्ज कराई",
                "invitation.safe.summary.active": "सक्रिय",
                "invitation.safe.summary.validated": "मान्य",
                "invitation.safe.summary.rejected": "अस्वीकार कर दिया",
                "invitation.safe.sent_invitations": "निमंत्रण जारी किये गये",
                "invitation.safe.table.id": "पहचान",
                "invitation.safe.table.invited_email": "अतिथि ईमेल",
                "invitation.safe.table.code": "कोड",
                "invitation.safe.table.status": "राज्य",
                "invitation.safe.table.created": "बनाया था",
                "invitation.safe.empty_sent": "अभी तक कोई निमंत्रण जारी नहीं किया गया.",
                "invitation.safe.simulated_rewards": "नकली पुरस्कार अर्जित किये गये",
                "invitation.safe.empty_rewards": "फिलहाल कोई नकली पुरस्कार नहीं.",
                "invitation.safe.error.load_status": "आमंत्रण स्थिति लोड नहीं हो सकी.",
                "invitation.safe.error.generate_code": "कोड जनरेट नहीं किया जा सका.",
                "invitation.safe.error.invalid_email": "आमंत्रण पंजीकृत करने के लिए एक वैध ईमेल दर्ज करें।",
                "invitation.safe.error.register_pending": "लंबित आमंत्रण पंजीकृत नहीं किया जा सका.",
                "invitation.safe.success.code_generated": "सफलतापूर्वक कोड जनरेट किया गया.",
                "invitation.safe.success.pending_registered": "लंबित आमंत्रण सुरक्षित मोड में पंजीकृत है.",
                "invitation.status.deleted": "सफाया",
                "invitation.deleted.tooltip": "यह आमंत्रण हटा दिया गया",
                "invitation.status.rejected": "अस्वीकार कर दिया",
                "invitation.status.bounced": "बाउंस",
                "invitation.status.unknown": "अज्ञात स्थिति",
                "dashboard.admin.title": "ग्रोथ मेट्रिक्स",
                "dashboard.admin.newUsersToday": "आज नए उपयोगकर्ता",
                "dashboard.admin.messagesSentToday": "आज संदेश भेजा गया",
                "dashboard.admin.translationsUsed": "अनुवाद का प्रयोग किया गया",
                "dashboard.admin.invitesCreated": "निमंत्रण बनाए गए",
                "dashboard.admin.invitesValidated": "मान्य निमंत्रण",
                "dashboard.admin.inviteConversion": "आमंत्रण रूपांतरण",
                "dashboard.admin.kFactor": "कश्मीर फैक्टर",
                "dashboard.admin.newUsers": "नए उपयोगकर्ता",
                "dashboard.admin.messagesSent": "सन्देश भेज दिया है",
                "dashboard.admin.noData": "कोई डेटा नहीं",
                "dashboard.admin.kFactor.viral": "वायरल",
                "dashboard.admin.kFactor.stable": "स्थिर",
                "dashboard.admin.kFactor.low": "कम",
                "dashboard.admin.emailMetrics": "ईमेल मेट्रिक्स",
                "dashboard.admin.email.sent": "भेजा",
                "dashboard.admin.email.delivered": "पहुंचा दिया",
                "dashboard.admin.email.opened": "खुला",
                "dashboard.admin.email.clicked": "क्लिक्स",
                "dashboard.admin.email.bounced": "बाउंस",
                "dashboard.admin.email.deliveryRate": "वितरण दर",
                "dashboard.admin.email.openRate": "खुली दर",
                "dashboard.admin.email.bounceRate": "बाउंस दर",
                "dashboard.admin.funnelMetrics": "फ़नल मेट्रिक्स",
                "dashboard.admin.funnel.registered": "दर्ज कराई",
                "dashboard.admin.funnel.confirmed": "की पुष्टि",
                "dashboard.admin.funnel.loggedIn": "सबसे पहले लॉगइन करें",
                "dashboard.admin.funnel.firstMessage": "पहला संदेश",
                "dashboard.admin.funnel.abandoned": "छोड़ा हुआ",
                "dashboard.admin.funnel.conversionRate": "रूपांतरण दर",
                "dashboard.admin.funnel.activationRate": "सक्रियण दर",
                "dashboard.admin.funnel.dropoffRate": "ड्रॉपआउट दर",
                "dashboard.admin.loading": "मेट्रिक्स लोड हो रहा है...",
                "dashboard.admin.errorLoad": "मेट्रिक्स डैशबोर्ड लोड नहीं किया जा सका.",
                "dashboard.admin.growthViral": "वायरल ग्रोथ",
                "dashboard.admin.growthStable": "स्थिर विकास",
                "dashboard.admin.growthLow": "कम वृद्धि",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "कोड",
                "errors.modal.message": "संदेश",
                "errors.modal.path": "मार्ग",
                "errors.modal.time": "घंटा",
                "errors.modal.timestamp": "समय-चिह्न",
                "errors.modal.copied": "विवरण कॉपी किया गया",
                "errors.network": "सर्वर से कनेक्ट नहीं हो पाया। अपना कनेक्शन जांचें.",
                "errors.unexpected": "एक अप्रत्याशित त्रुटि हुई। पुनः प्रयास करें।",
                "errors.boundary.title": "प्रतिक्रिया त्रुटि पकड़ी गई",
                "errors.boundary.request_id": "एक्स-अनुरोध-आईडी:",
                "errors.boundary.correlate": "बैकएंड/लॉग/structured.log पर मैप करें",
                "errors.boundary.message_label": "संदेश:",
                "errors.boundary.stack_trace": "स्टैक ट्रेस",
                "errors.boundary.component_stack": "घटक ढेर",
                "errors.boundary.empty": "(खाली)",
                "errors.boundary.reload_page": "पृष्ठ पुनः लोड करें",
                "errors.ui_boundary.refresh": "ArChat इंटरफ़ेस त्रुटि - पृष्ठ पुनः लोड करें",
                "bootstrap.error.title": "ArChat® - बूट त्रुटि",
                "common.reload": "फिर से दाम लगाना",
                "admin.access_denied.message": "संदेश",
                "admin.access_denied.title": "शीर्षक",
                "admin.action.change_plan": "योजना बदलें",
                "admin.action.reactivate": "पुन: सक्रिय",
                "admin.action.suspend": "निलंबित करें",
                "admin.action.view": "देखना",
                "admin.confirm.change_plan.message": "संदेश",
                "admin.confirm.change_plan.title": "शीर्षक",
                "admin.confirm.suspend.message": "संदेश",
                "admin.confirm.suspend.title": "शीर्षक",
                "admin.details.created": "बनाया था",
                "admin.details.current_plan": "वर्तमान योजना",
                "admin.details.domain": "कार्यक्षेत्र",
                "admin.details.last_activity": "अंतिम गतिविधि",
                "admin.details.name": "रतालू",
                "admin.details.plan": "योजना",
                "admin.details.status": "स्थिति",
                "admin.details.subscription": "सदस्यता",
                "admin.details.tenant_id": "किरायेदार आईडी",
                "admin.details.tenant_info": "किरायेदार की जानकारी",
                "admin.details.usage": "प्रयोग",
                "admin.error.change_plan": "योजना बदलें",
                "admin.error.generic": "सामान्य",
                "admin.error.load_details": "विवरण लोड करें",
                "admin.error.load_tenants": "किरायेदारों को लोड करें",
                "admin.error.reactivate": "पुन: सक्रिय",
                "admin.error.suspend": "निलंबित करें",
                "admin.error.title": "शीर्षक",
                "admin.filter.active": "सक्रिय करें",
                "admin.filter.all_plans": "सभी योजनाएं",
                "admin.filter.all_status": "सभी स्थिति",
                "admin.filter.suspended": "निलंबित करें",
                "admin.limit.devices": "उपकरण",
                "admin.limit.invitations": "आमंत्रण",
                "admin.limit.messages": "संदेशों",
                "admin.limit.storage": "भंडारण",
                "admin.limit.users": "उपयोगकर्ताओं",
                "admin.loading": "लोड हो रहा है",
                "admin.no_tenants": "गैर-किरायेदार",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "सक्रिय करें",
                "admin.status.suspended": "निलंबित करें",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "पिछला भुगतान",
                "admin.subscription.status": "स्थिति",
                "admin.subtitle": "उपशीर्षक",
                "admin.success.plan_changed": "योजना बदल गई",
                "admin.success.tenant_reactivated": "किरायेदार पुनः सक्रिय हो गया",
                "admin.success.tenant_suspended": "किरायेदार निलंबित",
                "admin.success.title": "शीर्षक",
                "admin.table.actions": "कार्रवाई",
                "admin.table.messages": "संदेशों",
                "admin.table.name": "रतालू",
                "admin.table.plan": "योजना",
                "admin.table.status": "स्थिति",
                "admin.table.storage": "भंडारण",
                "admin.table.tenant_id": "किरायेदार आईडी",
                "admin.table.users": "उपयोगकर्ताओं",
                "admin.title": "शीर्षक",
                "admin.usage.devices": "उपकरण",
                "admin.usage.invitations": "आमंत्रण",
                "admin.usage.messages": "संदेशों",
                "admin.usage.storage": "भंडारण",
                "admin.usage.users": "उपयोगकर्ताओं",
                "auth.login": "लॉग इन करें",
                "auth.register": "पंजीकरण करवाना",
                "auth.reset_password": "पासवर्ड रीसेट",
                "billing.cancel.button": "बटन",
                "billing.cancel.canceling": "रद्द कर रहा है",
                "billing.cancel.confirm": "पुष्टि करना",
                "billing.cancel.error": "गलती",
                "billing.cancel.success": "सफलता",
                "billing.character_billing.characters_used": "वर्णों का प्रयोग किया गया",
                "billing.character_billing.consumption_pct": "खपत पीसीटी",
                "billing.character_billing.days_remaining": "दिन शेष",
                "billing.character_billing.deletion_date": "हटाने की तिथि",
                "billing.character_billing.period_start": "अवधि प्रारंभ",
                "billing.character_billing.renewal_date": "नवीनीकरण दिनांक",
                "billing.character_billing.title": "शीर्षक",
                "billing.current_plan": "वर्तमान योजना",
                "billing.founder_badge": "संस्थापक बिल्ला",
                "billing.no_plans": "योजना मत बनाओ",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "अगला भुगतान",
                "billing.subscription.plan": "योजना",
                'billing.subscription.price': 'प्लान की कीमत',
                "billing.subscription.started": "शुरू कर दिया",
                "billing.subscription.status": "स्थिति",
                "billing.subscription.mp_flow.subscribe_failed": "सदस्यता प्रारंभ नहीं की जा सकी. पुनः प्रयास करें।",
                "billing.subscription.mp_flow.change_plan_failed": "योजना को बदला नहीं जा सका. पुनः प्रयास करें।",
                "billing.subscription.mp_status.pending": "कान की बाली",
                "billing.subscription.mp_status.authorized": "अधिकृत",
                "billing.subscription.mp_status.active": "सक्रिय",
                "billing.subscription.mp_status.paused": "रुका हुआ",
                "billing.subscription.mp_status.cancelled": "रद्द कर दिया गया",
                "billing.subscription.mp_status.inactive": "निष्क्रिय",
                "billing.subscription.mp_status.unknown": "एक अजनबी",
                "billing.unlimited": "असीमित",
                "billing.update_plan": "अद्यतन योजना",
                "billing.update_plan_modal.title": "शीर्षक",
                "billing.usage.loading": "लोड हो रहा है",
                "common.accept": "स्वीकार करना",
                "common.confirmPassword": "पासवर्ड की पुष्टि कीजिये",
                'common.continue': 'जारी रखें',
                "common.error": "गलती",
                "dashboard.upgrade.to_plan": "योजना के लिए",
                "emoji.noResults": "कोई परिणाम नहीं",
                "emoji.pick": "चुनना",
                "export.restricted.message": "संदेश",
                "export.restricted.title": "शीर्षक",
                "export.restricted.upgrade": "उन्नत करना",
                "founder.*": "*",
                "help.faq.a1": "ए 1",
                "help.faq.a2": "ए2",
                "help.faq.a3": "ए3",
                "help.faq.a4": "ए4",
                "help.faq.a5": "ए5",
                "help.faq.a6": "ए6",
                "help.faq.a7": "ए7",
                "help.faq.q1": "Q1",
                "help.faq.q2": "Q2",
                "help.faq.q3": "Q3",
                "help.faq.q4": "Q4",
                "help.faq.q5": "Q5",
                "help.faq.q6": "Q6",
                "help.faq.q7": "क्यू 7",
                "help.faq.title": "शीर्षक",
                "help.howWorks.step4.point7": "बिंदु7",
                "help.message_time_context.free_vs_pro": "मुफ़्त बनाम प्रो",
                "help.message_time_context.point5": "बिंदु5",
                "help.plans.enterprise.benefits": "फ़ायदे",
                "help.plans.enterprise.description": "विवरण",
                "help.plans.enterprise.title": "शीर्षक",
                "help.plans.foundation.devices": "उपकरण",
                "help.plans.free.description": "विवरण",
                "help.plans.free.devices": "उपकरण",
                "help.plans.free.limits": "सीमाएं",
                "help.plans.free.title": "शीर्षक",
                "help.plans.intro": "पहचान",
                "help.plans.pro.benefits": "फ़ायदे",
                "help.plans.pro.description": "विवरण",
                "help.plans.pro.devices": "उपकरण",
                'help.plans.pro.price': '$19 / माह',
                "help.plans.pro.title": "शीर्षक",
                "help.plans.pro.upgrade": "उन्नत करना",
                "help.plans.title": "शीर्षक",
                "help.plans.urgent_slots_badge": "अत्यावश्यक स्लॉट बैज",
                "help.slogan.final": "अंत",
                "help.suggestions.point1": "बिंदु 1",
                "help.suggestions.point2": "अंक 2",
                "help.suggestions.title": "शीर्षक",
                "invitation.already_contact_added": "संपर्क पहले ही जोड़ा जा चुका है",
                "invitation.already_contact_title": "पहले से ही संपर्क शीर्षक",
                "invitation.already_pending": "पहले से ही लंबित है",
                "invitation.language.invalid": "अमान्य",
                "message.send": "भेजना",
                "message.sendFile": "लेख्यपत्र भेज दें",
                "messages.conversations": "बात चिट",
                "messages.no_conversations_subtitle": "कोई वार्तालाप उपशीर्षक नहीं",
                "messages.no_conversations_title": "कोई वार्तालाप शीर्षक नहीं",
                "presence.custom.edit": "संपादन करना",
                "profile.enrichment.country": "देश",
                "profile.enrichment.country.select": "चुनना",
                "profile.enrichment.description": "विवरण",
                "profile.enrichment.org_size": "संगठन का आकार",
                "profile.enrichment.org_size.placeholder": "स्थान धारक",
                "profile.enrichment.save": "बचाना",
                "profile.enrichment.skip": "छोडना",
                "profile.enrichment.title": "शीर्षक",
                "profile.enrichment.usage_type.label": "लेबल",
                "profile.enrichment.usage_type.placeholder": "स्थान धारक",
                "profile.founderPosition": "संस्थापक पद",
                "settings.confirmations.description": "विवरण",
                "settings.confirmations.disable": "अक्षम करना",
                "settings.confirmations.title": "शीर्षक",
                "settings.confirmations.updated": "अद्यतन",
                "settings.title": "शीर्षक",
                "theme.description": "विवरण",
                "google.unavailable_tenant": "Google इस किरायेदार के लिए अनुपलब्ध है.",
                "google.unavailable": "गूगल अनुपलब्ध.",
                "google.verify_client_id": "Google क्लाउड कंसोल में क्लाइंट आईडी सत्यापित करें।",
                'google.login_aria': 'Google से साइन इन करें',
                "message.preview_alt": "पूर्व दर्शन",
                "message.image_attachment_alt": "संलग्न छवि",
                "profile.avatar.alt": "अवतार",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "शीर्ष आमंत्रणकर्ता लोड हो रहे हैं...",
                "invitation.top.empty": "अभी तक कोई विशेष आमंत्रितकर्ता नहीं.",
                "invitation.contacts.title": "संपर्कों को आमंत्रित करें",
                "invitation.contacts.safe_phase_note": "सुरक्षित चरण सक्रिय: वास्तविक सीमाओं पर प्रभाव डाले बिना लंबित लाभ।",
                "invitation.contacts.generate_code": "कोड/लिंक जनरेट करें",
                "invitation.contacts.refresh_top3": "शीर्ष 3 ताज़ा करें",
                "invitation.contacts.hide_full_ranking": "पूरी रैंकिंग छिपाएँ",
                "invitation.contacts.show_full_ranking": "पूरी रैंकिंग दिखाएं",
                "invitation.contacts.hide_metrics_dashboard": "मेट्रिक्स डैशबोर्ड छिपाएँ",
                "invitation.contacts.show_metrics_dashboard": "मेट्रिक्स डैशबोर्ड दिखाएँ",
                "invitation.contacts.prepared_link_label": "तैयार लिंक:",
                "invitation.contacts.email_placeholder": "email@domain.com",
                "invitation.contacts.register_pending": "लंबित आमंत्रण रजिस्टर करें",
                "invitation.contacts.status_summary": "स्थिति सारांश",
                "invitation.contacts.sent_invitations": "निमंत्रण भेजा",
                "invitation.contacts.invited_email": "आमंत्रित ईमेल",
                "invitation.contacts.code": "कोड",
                "invitation.contacts.no_sent_invitations": "मैंने अभी तक निमंत्रण नहीं भेजा है.",
                "invitation.contacts.simulated_rewards": "नकली पुरस्कार प्राप्त हुए",
                "invitation.contacts.no_simulated_rewards": "अभी तक कोई नकली पुरस्कार नहीं.",
                "common.id": "पहचान",
                "common.created": "बनाया था",
                'plan.pro_contacts': 'प्रति उपयोगकर्ता अधिकतम 100 संपर्क',
                "common.status": "स्थिति",
                "login.prompt_create_account_with_name": "क्या आप इस नाम से एक खाता बनाना चाहते हैं?",
                'plans.upgrade.title': 'योजना अपग्रेड करें',
                'plans.upgrade.comparison': 'योजना तुलना',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'कभी भी रद्द करें',
                'plans.actions.upgrade_pro': 'PRO में अपग्रेड करें',
                'plans.actions.become_founder': 'Founder बनें',

                'plans.modal.card.current_badge': 'आपकी वर्तमान योजना',

                'plans.modal.card.lower_tier': 'आपकी सक्रिय योजना से नीचे',

                'plans.modal.card.manage_in_profile': 'बदलने या रद्द करने के लिए: प्रोफ़ाइल में सदस्यता और बिलिंग।',
                'plans.modal.card.cancel_subscription': 'सदस्यता रद्द करें',
                'plans.modal.cancel_confirm.title': 'सदस्यता रद्द या प्रबंधित करें',
                'plans.modal.cancel_confirm.body': 'नए टैब में सुरक्षित Paddle पोर्टल खुलेगा—भुगतान, चालान या रद्द करने के लिए।',
                'plans.modal.cancel_confirm.continue_button': 'जारी रखें',
                'plans.modal.cancel_confirm.back_button': 'वापस',
                'plans.modal.cancel_paddle_fallback.title': 'सदस्यता प्रबंधित करें',
                'plans.modal.cancel_paddle_fallback.body': 'इस वातावरण में Paddle बिलिंग पोर्टल नहीं खुलता (जैसे स्थानीय विकास या लिंक नहीं)। आप यहीं योजनाएँ देख और तुलना कर सकते हैं।',
                'plans.modal.cancel_paddle_fallback.confirm': 'ठीक',
                'plans.upgrade_required': 'PRO प्लान पर उपलब्ध',
                'settings.heading': 'सेटिंग्स',
                'settings.dashboard': 'डैशबोर्ड',
                'settings.dashboardDescription': 'मुख्य पैनल और दिखाई देने वाले ब्लॉक के लिए स्थानीय सेटिंग।',
                'settings.dashboardGridHeading': 'पैनल ब्लॉक',
                'settings.dashboardShowOnStartDescription': 'चालू करने पर साइन इन के बाद संपर्क सूची के बजाय पैनल खुलता है।',
                'settings.dashboardBlockWelcome': 'स्वागत',
                'settings.dashboardBlockUsage': 'प्लान उपयोग',
                'settings.dashboardBlockFiles': 'मेरी फ़ाइलें',
                'settings.dashboardBlockPromotions': 'प्रोमो',
                'settings.dashboardBlockSessions': 'सत्र',
                'settings.dashboardWelcomeDescription': 'पहले कदम, संपर्क आमंत्रण और सहायता शॉर्टकट।',
                'settings.dashboardUsageDescription': 'सीमाओं बनाम उपयोग: संपर्क, अक्षर, स्टोरेज, डिवाइस।',
                'settings.dashboardFilesDescription': '«मेरी फ़ाइलें» में दिख रही फ़ाइलें और जगह का सार।',
                'settings.dashboardPromotionsDescription': 'प्रचार सारांश और प्रोग्राम लिंक।',
                'settings.dashboardSessionsDescription': 'सक्रिय सत्र और डिवाइस; जहाँ संभव अन्य सत्र बंद करें।',
                'settings.enabled': 'चालू',
                'settings.disabled': 'बंद',
                'settings.showDashboardOnStart': 'लॉगिन पर पैनल दिखाएँ',
                'settings.showWelcomeBlock': 'स्वागत ब्लॉक',
                'settings.showPromotionsBlock': 'प्रचार ब्लॉक',
                'settings.showUsageBlock': 'प्लान उपयोग',
                'settings.showRecentConversationsBlock': 'हाल की बातचीत दिखाएँ (प्रति संपर्क अंतिम संदेश)',
                'settings.showSessionsBlock': 'सक्रिय सत्र',
                'settings.showFilesBlock': 'फ़ाइल सारांश',
                'settings.dashboardLocalNote': 'जब तक प्रोफ़ाइल API नहीं, सेटिंग्स इस ब्राउज़र में सहेजी जाती हैं।',
                'settings.appearanceSettings': 'दिखावट',
                'settings.argentinaTheme': 'अर्जेंटीना थीम',
                'settings.darkMode': 'डार्क मोड',
                'settings.language': 'भाषा',
                'settings.messageSound': 'संदेश ध्वनि',
                'settings.playSoundDescription': 'नए संदेशों या महत्वपूर्ण अलर्ट के लिए ध्वनि बजाएं।',
                'settings.messageSoundEnabled': 'चालू',
                'settings.messageSoundDisabled': 'बंद',
                'settings.accountSettings': 'खाता',
                'settings.deleteAccount': 'खाता हटाएं',
                'settings.deleteAccountWarning': 'यह स्थायी है। आपका डेटा, संदेश, संपर्क और सेटिंग प्लेटफ़ॉर्म की हटाने की प्रक्रिया के अनुसार हटा दी जाएगी।',
                'settings.deleteMyAccount': 'मेरा खाता हटाएं',
                'dashboard.contacts': 'संपर्क',
                'dashboard.characters': 'अक्षर',
                'dashboard.storage': 'स्टोरेज',
                'dashboard.active_devices': 'सक्रिय डिवाइस',
                'dashboard.need_more_resources': 'क्या आपको और संसाधनों की आवश्यकता है?',
                'dashboard.upgrade_message': 'अधिक संपर्क, अक्षर, स्टोरेज और सक्रिय डिवाइस पाने के लिए अपना प्लान अपग्रेड करें।',
                'dashboard.upgrade_button': 'PRO में अपग्रेड करें',
                'dashboard.upgrade_button_pro': 'PRO में अपग्रेड करें',
                'dashboard.upgrade_button_foundation': 'FOUNDATION में अपग्रेड करें',
                'files.preview': 'पूर्वावलोकन',
                'files.previewFile': 'फ़ाइल पूर्वावलोकन',
                'files.previewUnavailable': 'पूर्वावलोकन उपलब्ध नहीं है।',
                'files.previewLoading': 'पूर्वावलोकन लोड हो रहा है…',
                'files.openPreview': 'पूर्वावलोकन',
                'files.downloadFile': 'फ़ाइल डाउनलोड करें',
                'files.downloadFailed': 'फ़ाइल डाउनलोड नहीं हो सकी। कनेक्शन और सत्र जाँचें और पुनः प्रयास करें।',
                'files.closePreview': 'पूर्वावलोकन बंद करें',
                'files.unsupportedPreview': 'इस प्रकार की फ़ाइल का कोई पूर्वावलोकन नहीं। विवरण देख सकते हैं या डाउनलोड कर सकते हैं।',
                'files.pdfPreviewHelp': 'ब्राउज़र एम्बेडेड PDF न दिखा सकता। खोलने के लिए डाउनलोड करें।',
                'files.labelFileType': 'प्रकार',
                'files.previewForbidden': 'पूर्वावलोकन की अनुमति नहीं है।',
                'files.previewNotFound': 'फ़ाइल उपलब्ध नहीं है या अब खाते में दिखाई नहीं देती।',
                'files.unavailableForFree': 'मेरी फ़ाइलें FREE प्लान में शामिल नहीं है।',
                'files.availableInFoundationAndPro': 'मेरी फ़ाइलें FOUNDATION और PRO में उपलब्ध है।',
                'files.filesFeatureRestricted': 'यह सुविधा आपके वर्तमान प्लान में उपलब्ध नहीं है।',
                'files.filesLoadError': 'फ़ाइलें लोड करते समय त्रुटि।',
                'files.uploadUnavailableForFree': 'FREE प्लान में फ़ाइल भेजना उपलब्ध नहीं है।',
                'files.uploadAvailableInFoundationAndPro': 'फ़ाइल अपलोड FOUNDATION और PRO में उपलब्ध है।',
                'files.recipientStorageFull': 'प्राप्तकर्ता के पास यह फ़ाइल पाने के लिए जगह नहीं है।',
                'files.recipientNoAvailableStorage': 'प्राप्तकर्ता के पास यह फ़ाइल पाने के लिए जगह नहीं है।',
                'files.storageQuotaExceeded': 'आप अपने प्लान की स्टोरेज सीमा तक पहुंच गए हैं।',
                'files.freeStorageLimit': 'FREE प्लान में प्राप्त फ़ाइलों के लिए 5 MB शामिल है।',
                'settings.unreadEmailReminderSection': 'अपठित सार ईमेल',
                'settings.unreadEmailReminderDescription': 'यदि नए संदेश या फ़ाइलें नीचे दिए समय से अधिक अपठित रहती हैं, तो ArChat एक संयुक्त सार ईमेल भेजता है (प्रति संदेश अलग नहीं)।',
                'settings.unreadEmailReminderToggle': 'मुझे ईमेल पर सार भेजें',
                'settings.unreadEmailDelayHours': 'भेजने से पहले प्रतीक्षा (घंटे)',
                'settings.unreadEmailDelayHint': '1–168 घंटे (अधिकतम एक सप्ताह)। ईमेल भाषा प्रोफ़ाइल से।',
                'subjects.title': 'विषय',
                'subjects.singular': 'विषय',
                'subjects.plural': 'विषय',
                'subjects.general': 'सामान्य',
                'subjects.new': 'नया विषय',
                'subjects.create': 'विषय बनाएं',
                'subjects.rename': 'नाम बदलें',
                'subjects.finish': 'समाप्त करें',
                'subjects.reopen': 'फिर से खोलें',
                'subjects.select': 'जारी रखें',
                'subjects.status.open': 'खुला',
                'subjects.status.pending': 'लंबित',
                'subjects.status.finished': 'समाप्त',
                'subjects.limitReached': 'इस बातचीत में सक्रिय विषयों की सीमा पूरी हो गई। नया बनाने के लिए पहले एक विषय समाप्त करें।',
                'subjects.limitReachedFree': 'FREE योजना: प्रति बातचीत अधिकतम 3 सक्रिय विषय। नया बनाने के लिए पहले एक विषय समाप्त करें।',
                'subjects.limitReachedPro': 'PRO योजना: प्रति बातचीत अधिकतम 5 सक्रिय विषय। नया बनाने के लिए पहले एक विषय समाप्त करें।',
                'subjects.limitReachedFoundation': 'FOUNDATION योजना: प्रति बातचीत अधिकतम 5 सक्रिय विषय। नया बनाने के लिए पहले एक विषय समाप्त करें।',
                'subjects.activeLimitsLine': 'सक्रिय विषय: {current} / {max}',
                'subjects.closedListTitle': 'बंद विषय',
                'subjects.viewClosed': 'बंद विषय देखें',
                'subjects.noClosedSubjects': 'कोई बंद विषय नहीं है।',
                'subjects.reopenSubject': 'फिर से खोलें',
                'subjects.reopenedSubjects': 'फिर से खोले गए विषय',
                'subjects.reopenLimitReached':
                  'आप सक्रिय विषयों की सीमा पर पहुँच गए हैं। इसे फिर से खोलने के लिए पहले कोई दूसरा विषय समाप्त करें।',
                'subjects.ownerOnlyReopen': 'केवल जिसने यह विषय बनाया है वही इसे फिर से खोल सकता है।',
                'subjects.modal.title': 'बातचीत के विषय',
                'subjects.modal.subtitle': 'इस बातचीत के विषयों को चुनें या प्रबंधित करें।',
                'subjects.contactLabel': 'संपर्क:',
                'subjects.ownerOnlyRename': 'केवल विषय बनाने वाला ही नाम बदल सकता है।',
                'subjects.ownerOnlyStateChange': 'केवल विषय बनाने वाला ही स्थिति बदल सकता है।',
                'subjects.createdByOther': 'यह विषय दूसरी पक्ष ने बनाया है। आप उत्तर दे सकते हैं, लेकिन नाम नहीं बदल सकते।',
                'subjects.empty': 'दिखाने के लिए कोई विषय नहीं।',
                'subjects.noResults': 'कोई विषय नहीं मिला।',
                'subjects.error.generic': 'कार्रवाई पूरी नहीं हो सकी। पुनः प्रयास करें।',
                'subjects.error.featureDisabled': 'इस वातावरण में विषय उपलब्ध नहीं हैं।',
                'subjects.error.duplicateName': 'इस नाम का एक सक्रिय विषय पहले से मौजूद है।',
                'subjects.error.ownerRequired': 'आपके पास इस विषय को संशोधित करने की अनुमति नहीं है।',
                'subjects.error.defaultCannotRename': 'सामान्य विषय का नाम नहीं बदला जा सकता।',
                'subjects.error.defaultCannotFinish': 'सामान्य विषय समाप्त नहीं किया जा सकता।',
                'subjects.current': 'विषय',
                'subjects.change': 'विषय बदलें',
                'subjects.currentLabel': 'विषय:',
                'subjects.changeSubject': 'विषय बदलें',
                'subjects.closedCannotSend': 'यह विषय समाप्त हो चुका है। नए संदेश भेजने के लिए इसे फिर से खोलें।',
                'subjects.selectBeforeSend': 'संदेश देखने और भेजने के लिए मोडल में एक विषय चुनें।',
                'subjects.loadingMessages': 'इस विषय के लिए संदेश लोड हो रहे हैं…',
                'subjects.messageFilterError': 'इस विषय के लिए संदेश लोड नहीं हो सके।',
                ...PRESET_LOCALES.hi,
                "auth.login.clear_password_lock_after_reset": "मैंने अपना पासवर्ड पहले ही बदल लिया है (उदाहरण के लिए किसी अन्य डिवाइस पर)",
                "auth.signup_disabled": "इस वातावरण में नया खाता पंजीकरण अस्थायी रूप से अक्षम है।",
                "auth.reset_user_not_found": "हमें उस ईमेल से संबद्ध कोई खाता नहीं मिला. जांचें कि यह सही ढंग से लिखा गया है या एक नया खाता बनाएं।",
                "account.not_found": "खाता नहीं मिला।",
                "auth.pending_activation.title": "खाता सक्रियण लंबित है",
                "auth.pending_activation.body": "आपका खाता अभी तक सक्रिय नहीं हुआ है. अपना ईमेल जांचें और ArChat में प्रवेश करने के लिए अपने पंजीकरण की पुष्टि करें।",
                "auth.pending_activation.back_to_login": "लॉगिन पर लौटें",
                "auth.pending_activation.support_prefix": "क्या आपको मदद की ज़रूरत है? समर्थन से संपर्क करें:",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "सक्रियण पुनः भेजने के लिए ईमेल करें",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "वह ईमेल दर्ज करें जिसके साथ आपने सक्रियण पुनः भेजने के लिए पंजीकरण किया था।",
                "auth.pending_activation.sent_title": "सक्रियण ईमेल भेजा गया",
                "auth.pending_activation.sent_body": "यदि ईमेल किसी लंबित खाते से संबंधित है, तो हम आपको एक नया सक्रियण लिंक भेजेंगे। अपना इनबॉक्स और स्पैम या जंक मेल भी जांचें।",
                "auth.pending_activation.soft_error_title": "पुनः भेजें उपलब्ध नहीं है",
                "auth.pending_activation.soft_error_body": "हम इस समय पुनः प्रेषण संसाधित करने में असमर्थ थे। कुछ मिनटों में पुनः प्रयास करें या हमें info@archat.com.ar पर लिखें।",
                "auth.pending_activation.resend_again": "पुनः भेजें",
                "menu.plans": "योजनाओं",
                "files.title": "मेरी फ़ाइलें",
                "files.filter_all": "सभी",
                "files.filter_sent": "भेजा",
                "files.filter_received": "प्राप्त",
                "files.filter_images": "इमेजिस",
                "files.filter_documents": "दस्तावेज़",
                "files.col_name": "नाम",
                "files.col_size": "आकार",
                "files.col_date": "तारीख",
                "files.col_direction": "डिर.",
                "files.col_actions": "कार्रवाई",
                "files.sent": "📤 भेजा गया",
                "files.received": "📥 प्राप्त हुआ",
                "files.download": "स्राव होना",
                "files.delete_for_me": "मेरे लिए हटाएं",
                "files.delete_confirm_title": "फ़ाइल नष्ट करें",
                "files.delete_confirm_message": "यह फ़ाइल आपके खाते से हटा दी जाएगी. इसे दूसरे व्यक्ति के लिए हटाया नहीं जाएगा. जारी रखना?",
                "files.empty": "आपके पास फ़ाइलें नहीं हैं.",
                "files.error_loading": "फ़ाइलें अपलोड करने में त्रुटि.",
                "files.load_more": "और लोड करें",
                "message.status.sending": "भेजा जा रहा है...",
                "message.status.failed": "नहीं भेजा गया",
                "message.status.sent": "भेजा",
                "message.status.delivered": "पहुंचा दिया",
                "message.status.read": "पढ़ना",
                "home.public_nav.pricing": "कीमतों",
                "home.public_nav.aria": "मुख्य साइट नेविगेशन",
                "home.public_footer.aria": "कानूनी कड़ियाँ",
                "home.pricing_link": "योजनाएं और कीमतें",
                "publicPricing.nav.back_home": "← घर",
                "publicPricing.title": "योजनाएं और कीमतें",
                "publicPricing.subtitle": "ArChat सदस्यता इंजन के लिए पारदर्शी और संरेखित सीमाएँ। अंतरराष्ट्रीय चेकआउट के लिए अमेरिकी डॉलर में वाणिज्यिक कीमतें (उदाहरण के लिए पैडल)।",
                "publicPricing.commercial_note": "कार्यात्मक सीमाएँ प्लानकॉन्स्टेंट्स/प्लानरिजॉल्वर से आती हैं; आपका खाता डेटाबेस में प्लान_लिमिट्स लागू कर सकता है। जैसा कि संकेत दिया गया है, मर्चेंट चार्जिंग यूएसडी मूल्य निर्धारण के साथ पैडल (या आर्कचैट द्वारा आधिकारिक तौर पर नामित अन्य प्रोसेसर) का उपयोग करता है।",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "PRO (प्रीमियम अनुबंध) के समान तकनीकी सीमाएँ।",
                "publicPricing.same_limits_foundation": "फाउंडेशन (प्रीमियम अनुबंध) के समान तकनीकी सीमाएँ।",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "प्रति खाता प्रति माह 30,000 अक्षर।",
                "publicPricing.free.b2": "प्रति उपयोगकर्ता अधिकतम 2 संपर्क; प्रति खाता अधिकतम 2 सक्रिय वार्तालाप।",
                "publicPricing.free.b3": "कोई अटैचमेंट या भंडारण स्थान नहीं; डेटा निर्यात के बिना.",
                "publicPricing.free.b4": "संदेश इतिहास 30 दिन तक; प्रति उपयोगकर्ता 1 डिवाइस.",
                "publicPricing.free.b5": "34 संदेश/दिन और 1,000 संदेश/माह (किरायेदार); प्रति दिन 20 निमंत्रण तक।",
                "publicPricing.premium.b1": "प्रति खाता प्रति माह 300,000 अक्षर; प्रति उपयोगकर्ता 100 संपर्क तक।",
                "publicPricing.premium.b2": "असीमित बातचीत और चैट (किरायेदार); 1,667 संदेश/दिन और 50,000/माह।",
                "publicPricing.premium.b3": "50 एमबी तक भंडारण (किरायेदार); प्रति उपयोगकर्ता 3 डिवाइस तक।",
                "publicPricing.premium.b4": "असीमित निमंत्रण (किरायेदार); योजना के अनुसार निर्यात, स्वचालित अनुवाद और फ़ाइलें।",
                "publicPricing.premium.b5": "फाउंडेशन: PRO के समान तकनीकी अनुबंध, साथ ही संस्थापक कार्यक्रम (150 स्थान)। प्रो: प्रीमियम मानक।",
                "publicPricing.foundation.founder_note": "संस्थापक वाणिज्यिक कार्यक्रम: स्थानों की सीमित संख्या (योजना सारांश देखें)। सदस्यता सक्रिय होने के बाद समान PRO सीमाएँ।",
                "publicPricing.cta.start_free": "मुफ्त खाता बनाओ",
                "publicPricing.cta.register_paid": "खाता बनाएं",
                "publicPricing.paddle_hint": "चार्जिंग सक्षम होने पर चुने हुए प्रोसेसर के साथ चेकआउट एप्लिकेशन के भीतर पूरा हो जाएगा।",
                "publicPricing.legal.nav_label": "कानूनी",
                "publicPricing.legal.terms": "सेवा की शर्तें",
                "publicPricing.legal.privacy": "गोपनीयता नीति",
                "publicPricing.legal.refund": "भुगतान वापसी की नीति",
                "profile.security.privacy_note": "अपने खाते की गोपनीयता और सुरक्षा प्रबंधित करें।",
                "profile.security.sessions_title": "सक्रिय सत्र",
                "profile.security.current": "वर्तमान सत्र",
                "profile.plan.foundation.description": "फाउंडेशन योजना (संस्थापक): संस्थापक कार्यक्रम और सीमित स्थान (150 सीटें) के साथ प्रो के समान प्रीमियम उपयोग।",
                "billing.view_plans": "योजनाएं देखें",
                "billing.paddle.cancel_via_portal": "सदस्यता रद्द करें",
                "billing.paddle.test_access_denied_body": "इस सर्वर पर, बिलिंग परिचालन प्रतिबंधित है (परीक्षण मोड या परीक्षण सूची)। यदि आपने पहले ही वास्तविक खाते से भुगतान कर दिया है, तो उत्पादन में सभी उपयोगकर्ताओं के लिए भुगतान की अनुमति दी जानी चाहिए (उदाहरण के लिए PAYMENTS_ALLOW_ALL_BILLING_USERS) या उस प्रतिबंध को अक्षम किया जाना चाहिए। समर्थन से संपर्क करें।",
                "attachment.storage_insufficient_precheck.title": "अपर्याप्त स्थान",
                "attachment.storage_insufficient_precheck.message": "फ़ाइल का वज़न {fileSizeMb} MB है और आपके पास केवल {availableMb} MB उपलब्ध है। जगह खाली करें या जारी रखने के लिए अपनी योजना में सुधार करें।",
                "attachment.files_disabled.title": "योजना की सीमा",
                "attachment.files_disabled.message": "आपकी वर्तमान योजना में फ़ाइल भेजना शामिल नहीं है. जारी रखने के लिए अपनी योजना में सुधार करें।",
                "contacts.viewContactInfo": "संपर्क विवरण देखें",
                "contacts.contactInfoTitle": "सम्पर्क करने का विवरण",
                "contacts.phone": "फ़ोन",
                "contacts.bio": "जीवनी",
                "contacts.notProvided": "बेख़बर",
                "contacts.unread.badge": "अपठित संदेश",
                "dashboard.recentInbound.title": "अंतिम संदेश प्राप्त हुए",
                "dashboard.recentInbound.empty": "आपके पास हाल ही में प्राप्त कोई संदेश नहीं है.",
                "dashboard.recentInbound.error": "संदेश लोड नहीं किये जा सके.",
                "dashboard.recentInbound.previewPhoto": "तस्वीर",
                "dashboard.recentInbound.previewFile": "पुरालेख",
                "dashboard.recentInbound.previewPdf": "पीडीएफ",
                "dashboard.recentInbound.previewUnavailable": "संदेश उपलब्ध नहीं है",
                "dashboard.recentInbound.readTitle": "पढ़ना",
                "dashboard.recentInbound.unreadTitle": "अपठित ग",
                "dashboard.recentConversations.title": "हाल की बातचीत",
                "dashboard.recentConversations.empty": "दिखाने के लिए कोई बातचीत नहीं है.",
                "dashboard.recentConversations.error": "बातचीत लोड नहीं की जा सकीं.",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "अनुवाद उपलब्ध नहीं है",
                "plan.errors.translationNotAllowed.message": "आपकी वर्तमान योजना में भाषाओं के बीच स्वचालित अनुवाद शामिल नहीं है।",
                "plan.errors.translationNotAllowed.solution": "स्वचालित अनुवाद का उपयोग करने के लिए, अपनी योजना को अपग्रेड करें।",
                "billing.subscription.cancel_scheduled_date": "आपकी सदस्यता {{दिनांक}} को रद्द होने वाली है। आप तब तक अपनी योजना का उपयोग जारी रख सकते हैं।",
                "billing.subscription.cancel_scheduled_badge": "{{दिनांक}} को रद्द किया गया",
                "billing.scheduled.plan_after_cancel_label": "अवधि के अंत में योजना बनाएं:",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "फ़ाउंडेशन में बदलें",
                "billing.scheduled.switch_to_free": "मुफ़्त में बदलें",
                "billing.scheduled.foundation_full_title": "फाउंडेशन उपलब्ध नहीं है",
                "billing.scheduled.foundation_full_message": "इस समय कोई फाउंडेशन स्पॉट उपलब्ध नहीं है। अवधि के अंत में आपकी योजना मुफ़्त हो जाएगी।",
                "billing.scheduled.saving": "सहेजा जा रहा है...",
                "billing.scheduled.error_title": "योजना बदलते समय त्रुटि",
                "billing.scheduled.error_generic": "निर्धारित योजना को बदला नहीं जा सका. पुनः प्रयास करें।",
                "billing.cancel_scheduled.title": "अनुसूचित रद्दीकरण",
                "billing.cancel_scheduled.desc": "आपकी सदस्यता {{दिनांक}} को रद्द कर दी जाएगी। आप तब तक अपनी वर्तमान योजना का उपयोग जारी रख सकते हैं।",
                "billing.cancel_scheduled.no_new_plan_until_end": "जब तक यह सदस्यता समाप्त नहीं हो जाती तब तक आप किसी अन्य योजना का अनुबंध नहीं कर सकेंगे।",
                "billing.cancel_scheduled.free_fallback": "यदि आप किसी भी योजना को नवीनीकृत नहीं करते हैं, तो आपका खाता संबंधित सीमाओं के साथ मुफ़्त में जारी रहेगा।",
                "billing.cancel_scheduled.profile_deactivation_hint": "आप अपनी प्रोफ़ाइल से प्लेटफ़ॉर्म से सदस्यता समाप्त भी कर सकते हैं।",
                "billing.cancel_scheduled.default_free": "अवधि के अंत में: मुफ़्त",
                "google.missing_client_id": "इस बिल्ड में Google साइन-इन उपलब्ध नहीं है: VITE_GOOGLE_CLIENT_ID (या __ARCHAT_TENANT_CONFIG__ में प्रति किरायेदार googleClientId) गायब है।",
                "reviews.title": "आर्कचैट समीक्षाएँ",
                "reviews.create_title": "आप ArChat को कैसे रेट करेंगे?",
                "reviews.edit_title": "मेरी समीक्षा संपादित करें",
                "reviews.comment_placeholder": "हमें अपने अनुभव के बारे में बताएं (वैकल्पिक)...",
                "reviews.submit_btn": "समीक्षा सबमिट करें",
                "reviews.update_btn": "अद्यतन",
                "reviews.thank_you": "आपकी समीक्षा के लिए धन्यवाद!",
                "reviews.submitted_message": "आपकी राय हमें बेहतर बनाने में मदद करती है.",
                "reviews.error_select_rating": "एक रेटिंग चुनें",
                "reviews.error_generic": "समीक्षा सबमिट करने में त्रुटि",
                "reviews.prompt_message": "क्या आपको आर्कचैट पसंद है? अपनी समीक्षा छोड़ें!",
                "reviews.rate_now": "योग्य",
                "reviews.later": "बाद में",
                "reviews.write_review": "समीक्षा लिखो",
                "reviews.edit_my_review": "मेरी समीक्षा संपादित करें",
                "reviews.no_reviews": "अभी तक कोई समीक्षा नहीं। पहले बनें!",
                "reviews.review_singular": "समीक्षा",
                "reviews.review_plural": "समीक्षा",
                "reviews.verified": "सत्यापित",
                "reviews.anonymous": "गुमनाम",
                "files.storageUsed": "उपयोग में लाया गया स्थान",
                "files.planQuota": "योजना कोटा",
                "files.availableStorage": "उपलब्ध",
                "files.usagePercent": "इस्तेमाल किया गया",
                "files.unlimited": "असीमित",
                "files.sentBy": "के द्वारा भेजा गया",
                "files.unknownUser": "उपयोगकर्ता",
                "settings.webPushSection": "सिस्टम सूचनाएं (पुश/PWA)",
                "settings.webPushDescription": "जब ऐप पृष्ठभूमि में हो या मोबाइल पर बंद हो तो नोटिफिकेशन की अनुमति देता है। बिल्ड में VAPID सार्वजनिक कुंजी (VITE_VAPID_PUBLIC_KEY) और सर्वर पर कुंजियों की आवश्यकता है। ब्राउज़र अनुमति सक्रिय करें और इस डिवाइस को पंजीकृत करें।",
                "settings.webPushButton": "पुश सूचनाएँ सक्रिय करें",
                "settings.webPushRegistering": "पंजीकरण हो रहा है...",
                "settings.webPushState.granted": "की अनुमति दी। यदि VAPID सही ढंग से सेट है, तो लॉग सर्वर पर भेजा गया था।",
                "settings.webPushState.denied": "अनुमति नहीं मिली। कृपया अपनी ब्राउज़र सेटिंग में इस साइट के लिए सूचनाएं सक्षम करें।",
                "settings.webPushState.default": "अनुमति का अनुरोध करने और डिवाइस को पंजीकृत करने के लिए बटन पर टैप करें।",
                "settings.webPushState.unsupported": "यह ब्राउज़र पुश नोटिफिकेशन का समर्थन नहीं करता है.",
                "settings.webPushVapidMissing": "इस फ्रंटएंड बिल्ड में VITE_VAPID_PUBLIC_KEY गायब है: पुश सदस्यता पूरी नहीं हो सकती।",
                "tags.etiquetas": "लेबल",
                "tags.manageTitle": "टैग प्रबंधित करें",
                "tags.manage": "🏷️ टैग",
                "tags.allTags": "सभी टैग",
                "tags.confirmDelete": "यह टैग हटाएं?",
                "tags.tagNamePlaceholder": "टैग नाम",
                "tags.create": "बनाएं",
                "tags.noTags": "कोई लेबल नहीं हैं. ऊपर एक बनाएं.",
                "tags.save": "रखना",
                "tags.edit": "संपादन करना",
                "tags.delete": "हटाना",
                "tags.assignTo": "के लिए आवंटित",
                "tags.noTagsToAssign": "कोई लेबल उपलब्ध नहीं है. पहले उन्हें बनाएं.",
                "tags.bgColor": "पृष्ठभूमि का रंग",
                "tags.textColor": "पाठ का रंग",
                "tags.selectTag": "एक लेबल चुनें",
                "templates.selectTitle": "टेम्पलेट्स",
                "templates.noTemplates": "कोई टेम्पलेट नहीं हैं. ऊपर एक बनाएं.",
                "templates.manage": "टेम्प्लेट प्रबंधित करें",
                "templates.confirmDelete": "यह टेम्प्लेट हटाएं?",
                "templates.manageTitle": "टेम्प्लेट प्रबंधित करें",
                "templates.titlePlaceholder": "टेम्पलेट शीर्षक",
                "templates.bodyPlaceholder": "मैंने टेम्पलेट संदेश लिखा...",
                "templates.create": "टेम्पलेट बनाएं",
                "templates.save": "रखना",
                "templates.edit": "संपादन करना",
                "templates.delete": "हटाना",
};

